interface SEOItem {
  title: string;
  description: string;
}

interface SEOConfig {
  default: SEOItem;
  articles: {
    [key: string]: SEOItem;
  };
}

export const seoConfig: SEOConfig = {
  default: {
    title: 'TikTok API for Business',
    description: 'TikTok API for Business is a series of interface services provided by TikTok for Business to developers. ' +
      'Through integrating and calling the TikTok API for Business interface, developers can leverage our interface to interact ' +
      'interact with TikTok Ads Manager, TikTok Accounts and TikTok Creator Marketplace functionalities.'
  },
  articles: {
    "1797738007505921": {
      "title": "About the Guide Guide | TikTok API for Business",
      "description": "Welcome to our comprehensive TikTok API for Business guide! In this guide, you'll learn what to do, when to use it, and what to check when implementing \"About."
    },
    "1847303035303106": {
      "title": "Create Upgraded Smart+ Catalog Ads for App Overview",
      "description": "This article walks you through the steps to create Upgraded Smart+ Catalog Ads for App using the Sales objective."
    },
    "1735713781404673": {
      "title": "Campaign Management | TikTok API for Business",
      "description": "You can use Campaign Management API to set up your campaigns, ad groups, and ads. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1735712062490625": {
      "title": "Overview Documentation | TikTok API for Business",
      "description": "Overview TikTok API for Business is a series of interface services provided by TikTok for Business to developers."
    },
    "1749537346290689": {
      "title": "Migrate Campaign Management APIs | TikTok API for Business",
      "description": "Please read the following guidance before you migrate your campaign management calls to v1.3. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740591846408194": {
      "title": "Migrate to v1.3 Guide | TikTok API for Business",
      "description": "As you start to migrate, please read this doc carefully to ensure a smooth transition. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1740579480076290": {
      "title": "V1.3 updates Overview | TikTok API for Business",
      "description": "Based on developer feedback, we've introduced TikTok API for Business v1.3. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1774488637039618": {
      "title": "Get region calling codes and region codes for phone numbers",
      "description": "Use this endpoint to retrieve the region codes, region names, and region calling codes for phone numbers."
    },
    "1847302878676994": {
      "title": "Create a regular Upgraded Smart+ Web Campaign Guide",
      "description": "A regular Upgraded Smart+ Web Campaign is an Upgraded Smart+ Web Campaign that doesn't use catalog products to deliver ads."
    },
    "1832798345014338": {
      "title": "Get trending search keywords | TikTok API for Business",
      "description": "Use this endpoint to retrieve the top 20 search keywords trending on TikTok or search keywords personalized for your Business Account."
    },
    "1740029175352322": {
      "title": "FAQs Best Practices | TikTok API for Business",
      "description": "This article provides a summary of FAQs related to API for Business. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1738947843447809": {
      "title": "Update a Billing Group | TikTok API for Business",
      "description": "Use this endpoint to update the settings of a Billing Group. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740245827044354": {
      "title": "Get the sharing log of an audience Best Practices",
      "description": "Use this endpoint to get the sharing log of an audience. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get the."
    },
    "1740304387032066": {
      "title": "API reference Overview | TikTok API (Best Practices)",
      "description": "Business Account is an unique type of TikTok account intended for use by businesses on TikTok. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1822001009002497": {
      "title": "Update a GMV Max Campaign | TikTok API for Business",
      "description": "Use this endpoint to update a GMV Max Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update a GMV Max."
    },
    "1767334250066945": {
      "title": "Update a Smart+ Campaign | TikTok API for Business",
      "description": "Use this endpoint to update a Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update a Smart+."
    },
    "1815051817073665": {
      "title": "Delete the authorization code of a TikTok post Guide",
      "description": "Use this endpoint to delete the authorization code of a TikTok post. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740307296329730": {
      "title": "CTA recommendations | TikTok API for Business",
      "description": "Due to various reasons, the call-to-action (CTA) texts selected by advertisers might not have the best results."
    },
    "1767334299811842": {
      "title": "Get Smart+ Campaigns | TikTok API for Business",
      "description": "Use this endpoint to obtain detailed information of Smart+ Campaigns and Smart Performance Web Campaigns."
    },
    "1740132982369282": {
      "title": "Catalog Video Templates | TikTok API for Business",
      "description": "This article explains \"Catalog Video Templates\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739953260466178": {
      "title": "Instant pages Overview | TikTok API for Business",
      "description": "An instant page is a fast-loading lightweight web page that loads up to 11 times faster on TikTok than a standard web page."
    },
    "1740492512449538": {
      "title": "Unbind an event source from a catalog Documentation",
      "description": "Use this endpoint to unbind an app event or a website event from a catalog in a Business Center. In this guide, you'll learn what to do, when to use it, and."
    },
    "1825107978583042": {
      "title": "Get frequent hashtags used in top 1000 mentioned posts",
      "description": "Use this endpoint to retrieve the top 20 hashtags in the captions of mentioned posts. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740858565852225": {
      "title": "Report Web Events in bulk | TikTok API for Business",
      "description": "Use this endpoint to report Web Events in bulk to reduce traffic to the TikTok API for Business. In this guide, you'll learn what to do, when to use it, and."
    },
    "1835247009119233": {
      "title": "Update a max delivery or creative boost session",
      "description": "Use this endpoint to update a max delivery session for a specific product or a creative boost session for a specific video within a Product GMV Max Campaign."
    },
    "1825117901366274": {
      "title": "Rate limits for TTO API | TikTok API for Business",
      "description": "This article explains \"Rate limits for TTO API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1816979158055937": {
      "title": "Get the message event sets for ad creation Overview",
      "description": "This article explains \"Get the message event sets for ad creation\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740132940622850": {
      "title": "Catalog Products Guide | TikTok API for Business",
      "description": "This article explains \"Catalog Products\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740132891438082": {
      "title": "Catalog Event Sources | TikTok API for Business",
      "description": "This article explains \"Catalog Event Sources\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740641357077505": {
      "title": "API reference Overview | TikTok API for (Overview)",
      "description": "This group consists of the following API endpoint. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"API reference\"."
    },
    "1762228483080193": {
      "title": "Delete an existing comment on an owned video Guide",
      "description": "Use this endpoint to delete an<strong> owned comment</strong> on an organic video posted by an owned TikTok Account."
    },
    "1747012327159809": {
      "title": "Create a Customer File Audience | TikTok API for Business",
      "description": "This article introduces how to create **Customer File Audiences** using Customer File API and Streaming API."
    },
    "1763590884474882": {
      "title": "Search for additional interest categories Overview",
      "description": "Use this endpoint to search for additional interest categories. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738855176671234": {
      "title": "Register as a developer | TikTok API for Business",
      "description": "Before you can create an app and start development, you need to register as a developer. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1753994928261122": {
      "title": "Transfer a pixel from advertiser to BC Documentation",
      "description": "Use this endpoint to transfer a pixel to a BC. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Transfer a pixel."
    },
    "1750361698613249": {
      "title": "Create Catalog Ads Guide | TikTok API for Business",
      "description": "This article introduces how to create Catalog Ads (formerly known as Video Shopping Ads (VSA) with products from catalogs)."
    },
    "1751087792726017": {
      "title": "Guides Best Practices | TikTok API for (Overview)",
      "description": "This guide walks you through reports in synchronous mode or asynchronous mode, and different report types."
    },
    "1854746404386113": {
      "title": "Create Upgraded Smart+ Ads with Website and App Optimization",
      "description": "This article walks you through the steps to create Upgraded Smart+ Ads with Website and App Optimization using the Sales objective."
    },
    "1775104887052289": {
      "title": "Get negative keywords | TikTok API for Business",
      "description": "Use this endpoint to get the list of negative keywords for Search Ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1842225226006530": {
      "title": "Create a Custom Conversion | TikTok API for Business",
      "description": "Use this endpoint to create a Custom Conversion for a Pixel or an App. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740317263937538": {
      "title": "(Deprecated) Submit materials | TikTok API for Business",
      "description": "Use this endpoint to submit materials for dynamic scene creation. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739047132614722": {
      "title": "Create a test lead Guide | TikTok API for Business",
      "description": "Use this endpoint to perform end-to-end testing for lead generation. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1813772238056449": {
      "title": "Check the UnionPay verification requirement for a business",
      "description": "Use this endpoint to check whether UnionPay verification is required for your business license. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740027794580481": {
      "title": "Get Sparks Ads authorization | TikTok API for Business",
      "description": "This article outlines how to use the TikTok One (TTO) API to request Spark Ads authorization for a creator's post."
    },
    "1847302988449921": {
      "title": "Create an Upgraded Smart+ Lead Generation (Tutorial)",
      "description": "This article introduces how to create an Upgraded Smart+ Lead Generation Campaign with optimization location as instant messaging apps."
    },
    "1738864800380930": {
      "title": "Run an asynchronous report | TikTok API for Business",
      "description": "You can run a report in an asynchronous mode when you’re not in a time-sensitive environment. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1825107991945218": {
      "title": "Reply to a mention in comments | TikTok API for Business",
      "description": "Use this endpoint to reply to a video comment or reply that mentions a business's handle. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1843337892165889": {
      "title": "Supported dimensions for Upgraded Smart+ Creative Overview",
      "description": "Dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1776065099288577": {
      "title": "Manage comments on owned TikTok videos Documentation",
      "description": "This article walks you through how to manage comments on owned TikTok videos. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1846868953025538": {
      "title": "Link a TikTok account to an ad account in Business Center",
      "description": "Use this endpoint to link a TikTok account to an ad account in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1749734684478466": {
      "title": "HTTP Status Codes Guide | TikTok API for Business",
      "description": "HTTP Status Codes help you properly handle Success and Errors with TikTok for Business APIs. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740491257516034": {
      "title": "Get available regions | TikTok API for Business",
      "description": "Use this endpoint to query for the countries and regions that ads for a catalog can be delivered to."
    },
    "1739067487319042": {
      "title": "Creative reports Guide | TikTok API for Business",
      "description": "Creative asset level reporting is essential to understand how an advertiser's creative assets resonate with their target audience."
    },
    "1771101162079234": {
      "title": "Responses and errors | TikTok API for Business",
      "description": "This article explains \"Responses and errors\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843697551083522": {
      "title": "Enable or disable Comment-to-Message for a Business Account",
      "description": "Use this endpoint to enable or disable the Comment-to-Message feature for a Business Account. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1771100865818625": {
      "title": "Setup guide for Web | TikTok API for Business",
      "description": "This article explains \"Setup guide for Web\" and provides practical guidance for working with TikTok API for Business."
    },
    "1768657234981890": {
      "title": "Estimated integration time | TikTok API for Business",
      "description": "This article introduces the estimated integration time needed for some common API integration use cases."
    },
    "1739029234526209": {
      "title": "Update a blocked word | TikTok API for Business",
      "description": "Use this endpoint to replace a blocked word with another word. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1826537624043586": {
      "title": "Available endpoints in API Playground Documentation",
      "description": "The following table lists the available endpoints in [API Playground](https://business-api.tiktok.com/portal/docs?id=1826537506816001)."
    },
    "1740051721711618": {
      "title": "Get info about images | TikTok API for Business",
      "description": "Use this endpoint to obtain the information of images from the Asset Library. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1836584551347201": {
      "title": "Link a video to a TTO Creator Marketplace campaign as a",
      "description": "Use this endpoint to link a video to a TikTok One (TTO) Creator Marketplace campaign as a TikTok creator."
    },
    "1761237001980929": {
      "title": "Obtain details about location targeting tags by ID",
      "description": "Use this endpoint to get information about location targeting tags by ID. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1834913554657282": {
      "title": "Get Authorized TTO Media Insights Best Practices",
      "description": "Use this endpoint to get the reporting insights of videos of a TikTok creator who has joined TikTok One (TTO)."
    },
    "1742668948278274": {
      "title": "Use split tests Guide | TikTok API for Business",
      "description": "This article mainly introduces different use cases of split tests. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740489551354881": {
      "title": "Get estimated info of R&F ad groups Best Practices",
      "description": "Use this endpoint to query the estimated daily cost and frequency distribution. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1771101303285761": {
      "title": "Report App, Web, Offline, or CRM Events Overview",
      "description": "Use this endpoint to report a single App, Web, Offline, or CRM (Customer relationship management) event, or multiple App, Web, Offline, or CRM events in batch."
    },
    "1853377390815233": {
      "title": "Create an Upgraded Smart+ non-DC App Campaign Guide",
      "description": "An Upgraded Smart+ non-DC App Campaign is an Upgraded Smart+ App Campaign with iOS 14 dedicated campaign setting disabled and without using a catalog."
    },
    "1739939095321601": {
      "title": "Process a payment Guide | TikTok API for Business",
      "description": "This article explains \"Process a payment\" and provides practical guidance for working with TikTok API for Business."
    },
    "1749019676181505": {
      "title": "Premium Add-ons Guide | TikTok API for Business",
      "description": "You can enhance your ads with any of the following three Premium Add-on types as interactive add-ons."
    },
    "1751617882108929": {
      "title": "Supported metrics Guide | TikTok API for Business (Help)",
      "description": "You can use the following metrics in playable ad reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1825299576698882": {
      "title": "Check the status of an MMM data request Overview",
      "description": "Use this endpoint to check the status of a Media Mix Modeling (MMM) data request. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1839157972427970": {
      "title": "Manage Payment Portfolios | TikTok API for Business",
      "description": "This article walks you through how to manage Payment Portfolios using Payment Portfolios API. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740317791125506": {
      "title": "Ads preview Overview | TikTok API for Business",
      "description": "You can preview the following ad types. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Ads preview\"."
    },
    "1740665303669761": {
      "title": "(Deprecated) Update the name of a video package",
      "description": "Use this endpoint to update the name of a video package. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1751087777884161": {
      "title": "Overview Documentation | TikTok API (Overview)",
      "description": "This article gives an overview of Reporting API. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Overview\"."
    },
    "1749001669670913": {
      "title": "Get the details of an Asset Group Best Practices",
      "description": "Use this endpoint to get the assets or members of an Asset Group in a Business Center. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1810521739537409": {
      "title": "Subscribe to ad account Webhook events via Subscription API",
      "description": "This article explains \"Subscribe to ad account Webhook events via Subscription API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825103301081169": {
      "title": "Mentions API Overview | TikTok API for Business",
      "description": "Mentions API is a tool for monitoring mentions and analyzing community conversations towards your business on TikTok."
    },
    "1825107837430850": {
      "title": "Mentions Documentation | TikTok API for Business",
      "description": "Mentions API is a tool for monitoring mentions and analyzing community conversations about your business on TikTok."
    },
    "1776454619412481": {
      "title": "Run a Smart+ Campaign report | TikTok API for Business",
      "description": "This article explains \"Run a Smart+ Campaign report\" and provides practical guidance for working with TikTok API for Business."
    },
    "1855007163018689": {
      "title": "Create Upgraded Smart+ Non-Catalog Ads with Website and App",
      "description": "This article explains \"Create Upgraded Smart+ Non-Catalog Ads with Website and App Optimization\" and provides practical guidance for working with TikTok API."
    },
    "1752256376677378": {
      "title": "Get the quota for a SKAN Dedicated Campaign per ad network",
      "description": "This article explains \"Get the quota for a SKAN Dedicated Campaign per ad network\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740052016789506": {
      "title": "Search for images Guide | TikTok API for Business",
      "description": "Use this endpoint to search for image creatives in an advertising account's Asset Library. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1783164826830849": {
      "title": "Enable Smart Targeting for your ad groups Overview",
      "description": "This article walks you through the steps to enable Smart Targeting for your ad groups. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1780896521680898": {
      "title": "Get CRM Event Sets Guide | TikTok API for Business",
      "description": "Use this endpoint to get a list of CRM (Customer relationship management) Event Sets within an advertiser account."
    },
    "1825128393150530": {
      "title": "Spark Ads Recommendation API | TikTok API for (Guide)",
      "description": "This article explains \"Spark Ads Recommendation API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738947780033537": {
      "title": "Create a Billing Group | TikTok API for Business",
      "description": "Use this endpoint to create a Billing Group in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1826564965840066": {
      "title": "Get webpage anchors | TikTok API for Business",
      "description": "Use this endpoint to retrieve existing webpage anchors within your TikTok One (TTO) Creator Marketplace account."
    },
    "1739584864945154": {
      "title": "Event deduplication | TikTok API for Business",
      "description": "This article explains \"Event deduplication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843312888885314": {
      "title": "Update the operation statuses of Upgraded Smart+ Campaigns",
      "description": "Use this endpoint to enable, pause, or delete Upgraded Smart+ Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1774482976097281": {
      "title": "Create a Lead Generation ad with optimization (Guide)",
      "description": "This article introduces how to create a Lead Generation ad with optimization location as Website, driving lead-related actions on your website."
    },
    "1847302998941697": {
      "title": "Create an Upgraded Smart+ Lead Generation Campaign (Help)",
      "description": "This article introduces how to create an Upgraded Smart+ Lead Generation Campaign with optimization location as phone call."
    },
    "1745292444424193": {
      "title": "Bidding Best Practices | TikTok API for Business",
      "description": "Bidding is important to the overall ad creation process. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Bidding\"."
    },
    "1739939404802049": {
      "title": "Get the members of a BC | TikTok API for Business",
      "description": "Use this endpoint to get members in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get the."
    },
    "1739067551410178": {
      "title": "Supported metrics in creative basic reports Guide",
      "description": "This article explains \"Supported metrics in creative basic reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1742666543736834": {
      "title": "Run the winning ad group | TikTok API for Business",
      "description": "Use this endpoint to run the winning ad group in your ad group level split test. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739089635852289": {
      "title": "(Deprecated) Create a Smart Video Soundtrack task",
      "description": "Use this endpoint to create a Smart Video Soundtrack task. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1742666522399746": {
      "title": "End a split test Guide | TikTok API for Business",
      "description": "Use this endpoint to stop an ad group level or campaign level split test. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739578477445121": {
      "title": "API reference Overview | TikTok API for Business (Help)",
      "description": "The Catalog API consists of the following groups of endpoints: # Catalog Management * [Create a catalog](https://ads.tiktok.com/marketing_ap."
    },
    "1832184206708737": {
      "title": "Data security and privacy review | TikTok API for Business",
      "description": "Protecting customer data TikTok, like many organizations, faces cybersecurity threats and is committed to protecting the data of TikTok users."
    },
    "1843324618421314": {
      "title": "Create Upgraded Smart+ Automotive Ads Documentation",
      "description": "This section walks you through the steps to create Upgraded Smart+ Automotive Ads. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740317360823297": {
      "title": "(Deprecated) Get all videos | TikTok API for Business",
      "description": "Use this endpoint to get all videos that are generated from a material package. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1741601162187777": {
      "title": "Report web events and parameters | TikTok API for Business",
      "description": "This article explains \"Report web events and parameters\" and provides practical guidance for working with TikTok API for Business."
    },
    "1832184250237954": {
      "title": "Manage automatic messages for a Business Account",
      "description": "This article walks you through the steps to manage automatic messages for a Business Account. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740029915327489": {
      "title": "Get form libraries Guide | TikTok API for Business",
      "description": "Use this endpoint to get form libraries that you have access to. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1775747465089026": {
      "title": "Supported dimensions | TikTok API for Business (Help)",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1739581925704769": {
      "title": "Guides Best Practices | TikTok API for Business (Tutorial)",
      "description": "This guide walks you through the general workflow of managing TikTok Store via API. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739314549888002": {
      "title": "Ad Groups Documentation | TikTok API for Business",
      "description": "Ad groups are the middle level of advertising. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Ad Groups\"."
    },
    "1835087630325761": {
      "title": "Pixel integration with Gateway | TikTok API for Business",
      "description": "This article explains \"Pixel integration with Gateway\" and provides practical guidance for working with TikTok API for Business."
    },
    "1745292553358338": {
      "title": "Create an ad Overview | TikTok API for Business",
      "description": "This article introduces how to create an ad. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an ad\"."
    },
    "1746998676042753": {
      "title": "Create an audience Guide | TikTok API for Business",
      "description": "This topic discusses how to create audiences by using [Audience](https://business-api.tiktok.com/portal/docs?id=1739940398505986) API."
    },
    "1740858779758593": {
      "title": "Create a pixel Overview | TikTok API for Business",
      "description": "Use this endpoint to create a Pixel and install it on your website. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740040177229826": {
      "title": "Get the Pangle audience packages | TikTok API for Business",
      "description": "Use this endpoint to get the Pangle audience packages that are available to an advertiser. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1740490147129345": {
      "title": "Get R&F time zones Guide | TikTok API for Business",
      "description": "Use this endpoint to get the R&F delivery time zone according to location (country code)（for R&F advertising only)."
    },
    "1759233561597954": {
      "title": "Get the available regions for a Showcase via identity",
      "description": "This article explains \"Get the available regions for a Showcase via identity\" and provides practical guidance for working with TikTok API for Business."
    },
    "1758526151905281": {
      "title": "Campaign creation Guide | TikTok API for Business",
      "description": "This chapter consists of the following use cases: - [Create Traffic ads](https://business-api.tiktok.com/portal/docs?id=1782086026530817) -."
    },
    "1855460985594881": {
      "title": "Discover new keywords | TikTok API for Business",
      "description": "Use this endpoint to discover new keywords and explore keyword ideas to reach people interested in your business."
    },
    "1842225247176705": {
      "title": "Update a Custom Conversion | TikTok API for Business",
      "description": "Use this endpoint to update a Custom Conversion for a Pixel or an App. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1843309500205058": {
      "title": "Create Upgraded Smart+ App Campaigns Documentation",
      "description": "This article walks you through the steps to create Upgraded Smart+ App Campaigns using the App Promotion objective."
    },
    "1758051319816193": {
      "title": "Get Started Overview | TikTok API for Business (Guide)",
      "description": "This guide walks you through the process of setting up Offline Events API. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739940504185857": {
      "title": "Audience segment Guide | TikTok API for Business",
      "description": "Streaming API can be used to build target custom audiences for multiple advertisers at a time for both first and third party data."
    },
    "1739052936772610": {
      "title": "Create a lead download task | TikTok API for Business",
      "description": "Use this endpoint to create a download task for all the leads for the `page_id` or `ad_id` passed in the request."
    },
    "1740859338750977": {
      "title": "Get App Conversion Events | TikTok API for Business",
      "description": "Use this endpoint to obtain information about an app conversion event. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825128584099841": {
      "title": "Spark Ads Recommendation | TikTok API for Business",
      "description": "This article explains \"Spark Ads Recommendation\" and provides practical guidance for working with TikTok API for Business."
    },
    "1765596808589313": {
      "title": "Get Offline Event sets | TikTok API for Business",
      "description": "Use this endpoint to get a list of Offline Event sets under an advertiser account. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1751625296192514": {
      "title": "Supported filters Guide | TikTok API for (Overview)",
      "description": "You can use the following filters to narrow down the scope of reporting results. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1781992772171778": {
      "title": "Manage the balance allocation of Business Centers",
      "description": "This article walks you through the steps to manage the balance allocation of Business Centers that have enabled Balance Sharing."
    },
    "1769325368603650": {
      "title": "Get the list of added URL properties under an ad account",
      "description": "Use this endpoint to get the list of URL properties that have been added to an advertiser account. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740052369141761": {
      "title": "Music Best Practices | TikTok API for Business",
      "description": "This article explains \"Music\" and provides practical guidance for working with TikTok API for Business."
    },
    "1746624508278786": {
      "title": "Accounts Insights data latency | TikTok API for Business",
      "description": "This article explains \"Accounts Insights data latency\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740218522178562": {
      "title": "Get info about TikTok posts | TikTok API for Business",
      "description": "Use this endpoint to get the information about one or more TikTok posts that you published using the `AUTH_CODE`, `TT_USER` or `BC_AUTH_TT` identity."
    },
    "1748896852671489": {
      "title": "Guides Best Practices | TikTok API for Business (Guide)",
      "description": "This guide walks you through available creative assets, tools, and reports and how to use these assets and tools."
    },
    "1774487686007810": {
      "title": "Get the verification results of an URL Documentation",
      "description": "Use this endpoint to check whether an URL is a custom URL scheme, Apple’s universal link, or Android App Link, and whether the URL is valid."
    },
    "1775798662604802": {
      "title": "Reporting Documentation | TikTok API for Business (Guide)",
      "description": "This article explains \"Reporting\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740302665828417": {
      "title": "Reporting Documentation | TikTok API for (Overview)",
      "description": "You can use Reporting APIs to run a report on your auction ads and reservation ads data, in synchronous mode or asynchronous mode."
    },
    "1780156510696449": {
      "title": "Create a Saved Audience | TikTok API for Business",
      "description": "This article introduces how to create a Saved Audience. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a."
    },
    "1740857868662786": {
      "title": "App Events Documentation | TikTok API for Business",
      "description": "This article explains \"App Events\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739662756510721": {
      "title": "Add a partner to a BC | TikTok API for Business",
      "description": "Use this endpoint to add a partner and optionally share your assets to a Business Center. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1739585702922241": {
      "title": "Install Pixel using code | TikTok API for Business",
      "description": "Before you begin * You must have created a pixel in Events Manager and have access to the pixel base code."
    },
    "1833997665030145": {
      "title": "Revoke a short-term access token | TikTok API for Business",
      "description": "Use this endpoint to revoke a short-term access token. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Revoke a."
    },
    "1740858807646209": {
      "title": "Create Pixel Events | TikTok API for Business",
      "description": "Use this endpoint to create Pixel Events. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create Pixel Events\"."
    },
    "1846770644217858": {
      "title": "Create a product set by file | TikTok API for Business",
      "description": "Use this endpoint to create an E-commerce product set by uploading a CSV file containing SKU IDs in an E-commerce catalog under your Business Center."
    },
    "1832184116746305": {
      "title": "Get started Overview | TikTok API for Business (Help)",
      "description": "Welcome to Business Messaging API! In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get started\"."
    },
    "1740649343188994": {
      "title": "API reference Overview | TikTok API (Guide)",
      "description": "The reporting API consists of the following endpoints. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"API."
    },
    "1799004034003969": {
      "title": "TikTok Pixel only setup | TikTok API for Business",
      "description": "To install TikTok Pixel and configure events sent to TikTok through TikTok Pixel, you can add TikTok Pixel tags to your Google Tag Manager (GTM) web container."
    },
    "1819583269559297": {
      "title": "Verify Events API setup | TikTok API for Business (Guide)",
      "description": "This article introduces how to verify app data connection setup. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1843325022799873": {
      "title": "Create Upgraded Smart+ Automotive Ads for Models",
      "description": "Upgraded Smart+ Automotive Ads for Models are Upgraded Smart+ Automotive Ads created using an Auto-Model catalog."
    },
    "1771117279175682": {
      "title": "Create an asynchronous download task for catalog product",
      "description": "Use this endpoint to create an asynchronous download task for catalog product diagnostic information."
    },
    "1739562432184322": {
      "title": "Overview Documentation | TikTok API for Business (Help)",
      "description": "This article explains \"Overview\" and provides practical guidance for working with TikTok API for Business."
    },
    "1815693549459458": {
      "title": "Create or update a TTO Creator Marketplace campaign",
      "description": "Use this endpoint to create or update a TikTok One (TTO) Creator Marketplace campaign. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1749819287162881": {
      "title": "FAQs Best Practices | TikTok API (Best Practices)",
      "description": "**Q1: I see 40001 response code like the following instead of 0, what can I do?** A1: Make sure you are the admin or operator under this advertiser account."
    },
    "1758615097524225": {
      "title": "Apply audiences to ad groups | TikTok API for Business",
      "description": "Use this endpoint to apply audience to or disconnect audience from multiple ad groups. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1738824501176321": {
      "title": "Get ad benchmarks Guide | TikTok API for Business",
      "description": "Use this endpoint to get the performance data of ads against benchmarks. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739470947488770": {
      "title": "(Deprecated) Create Dynamic Showcase Ads Overview (Guide)",
      "description": "To create Dynamic Showcase Ads, please follow the steps: 1. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1744571205201922": {
      "title": "Create a Reach & Frequency campaign Best Practices",
      "description": "This article introduces how to create a Reach & Frequency (R&F) campaign. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825128684907522": {
      "title": "Get Spark Ads video recommendations for a Business Account",
      "description": "Use this endpoint to obtain the Spark Ads recommendation results for up to 20 TikTok video posts within your Business Account."
    },
    "1832183871604753": {
      "title": "Business Messaging API | TikTok API for Business",
      "description": "This article explains \"Business Messaging API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740559669226498": {
      "title": "Get review info of ads | TikTok API for Business",
      "description": "Use this endpoint to get information about the review of ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1749019652141058": {
      "title": "Cards Best Practices | TikTok API for Business",
      "description": "You can enhance your ads with any of the following six Card types as interactive add-ons. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1775752357139457": {
      "title": "Get currencies and registration areas for ad accounts",
      "description": "Use this endpoint to retrieve the currencies and places of registration for ad accounts within a Business Center."
    },
    "1767959274087425": {
      "title": "Smart+ Campaign Guide | TikTok API for Business",
      "description": "Smart+ Campaign is TikTok's AI-powered flagship automation solution to maximize your delivery outcomes with less effort from your side."
    },
    "1739591133130817": {
      "title": "Update the budgets of ad groups | TikTok API for Business",
      "description": "This article explains \"Update the budgets of ad groups\" and provides practical guidance for working with TikTok API for Business."
    },
    "1741942291730434": {
      "title": "Create Video Shopping Ads | TikTok API for Business",
      "description": "You can create Video Shopping Ads with products from catalogs, TikTok Commerce, or Showcase. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1844612550411265": {
      "title": "TikTok’s Politics, Governments, and Elections Advertising",
      "description": "All businesses advertising on TikTok must comply with our politics, governments, and elections advertising policy."
    },
    "1832184391220417": {
      "title": "Automatic messages Guide | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Create an automatic message for a Business Account](https://business-api.tiktok.com/porta."
    },
    "1739940539757569": {
      "title": "Delete audiences Guide | TikTok API for Business",
      "description": "Use this endpoint to delete audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete audiences\"."
    },
    "1740858823774210": {
      "title": "Update a Pixel Event | TikTok API for Business",
      "description": "Use this endpoint to update the name of a Pixel event and the conversion value. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1805640864553985": {
      "title": "Get filters for catalog product insights Overview",
      "description": "Use this endpoint to obtain the available filters for generating targeted insights on a limited number of products within an E-commerce catalog."
    },
    "1810515090228226": {
      "title": "Post publishing events | TikTok API for Business",
      "description": "Post publishing events provide you with real-time updates on the status of content published via specific TikTok API endpoints."
    },
    "1740665225631810": {
      "title": "Get the log of a feed | TikTok API for Business",
      "description": "Use this endpoint to return the last 10 operations to the feed. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1831358502098946": {
      "title": "Get the details of a comment mention from webhooks",
      "description": "This article explains \"Get the details of a comment mention from webhooks\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739939078695937": {
      "title": "BC Payments Overview | TikTok API for Business",
      "description": "This article explains \"BC Payments\" and provides practical guidance for working with TikTok API for Business."
    },
    "1830215925061633": {
      "title": "Get details of videos in customized posts Overview",
      "description": "Use this endpoint to retrieve the details of videos that have been used in the customized post collection for a Product GMV Max Campaign."
    },
    "1847839781968897": {
      "title": "Upgraded Smart+ ad creative combinations by identity and ad",
      "description": "The following table outlines the various combinations of ad creative combinations based on identity type and ad type."
    },
    "1739581901879298": {
      "title": "TikTok Store Overview | TikTok API for Business",
      "description": "TikTok Store API enables you to retrieve first-party stores (TikTok Shops) under an ad account and products within TikTok Shops."
    },
    "1803655061642242": {
      "title": "Get the catalog video handling log Best Practices",
      "description": "Use this endpoint to check if the catalog videos are uploaded successfully, and what to do if the upload fails."
    },
    "1738864960144385": {
      "title": "DSA reports Overview | TikTok API for Business",
      "description": "This article explains \"DSA reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1754162402455554": {
      "title": "Create Live Shopping Ads | TikTok API for Business",
      "description": "This article introduces how to create Live Shopping Ads (LSA). In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1850030360880129": {
      "title": "Guidelines for identifier normalization Overview",
      "description": "This article explains \"Guidelines for identifier normalization\" and provides practical guidance for working with TikTok API for Business."
    },
    "1837247726007298": {
      "title": "Get TTO video linking requests as a creator Guide",
      "description": "Use this endpoint to retrieve the requests for linking your public videos to TikTok One (TTO) Creator Marketplace campaigns."
    },
    "1765926674648065": {
      "title": "Obtain the authorized Creator permissions Overview",
      "description": "This article explains \"Obtain the authorized Creator permissions\" and provides practical guidance for working with TikTok API for Business."
    },
    "1741942179356738": {
      "title": "Create Shopping Ads | TikTok API for Business",
      "description": "This article walks you through the steps to create Shopping Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1799004097478658": {
      "title": "Set up events with data layer | TikTok API for Business",
      "description": "The data layer is an object used by Google Tag Manager (GTM) and `gtag.js` to pass information to tags."
    },
    "1833997679342594": {
      "title": "Renew a short-term access token | TikTok API for Business",
      "description": "Use this endpoint to renew a short-term access token by `refresh_token`. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1744571201117186": {
      "title": "About Reach & Frequency | TikTok API for Business",
      "description": "Reach & Frequency enables predictable reach, controlled frequency and guaranteed delivery with a more flexible and transparent ad experience."
    },
    "1825127469285442": {
      "title": "Overview Documentation | (Best Practices)",
      "description": "This article explains \"Overview\" and provides practical guidance for working with TikTok API for Business."
    },
    "1839151998450754": {
      "title": "Allocate the credit line to Payment Portfolios Guide",
      "description": "Use this endpoint to allocate the credit line of a client to one or more Payment Portfolios. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1771117294731266": {
      "title": "Download asynchronous catalog product diagnostic information",
      "description": "Use this endpoint to download a CSV file of catalog product diagnostic information. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739591716326402": {
      "title": "Update the statuses of ad groups | TikTok API for Business",
      "description": "Use this endpoint to enable, disable or delete an ad group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update."
    },
    "1832184264385538": {
      "title": "Manage the welcome message for a Business Account",
      "description": "This article walks you through the steps for managing the welcome message for a Business Account using Business Messaging API."
    },
    "1824722485971009": {
      "title": "Metrics in GMV Max Campaign reports Best Practices",
      "description": "This article summarizes the supported metric types for GMV Max Campaign reports. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1829635758164994": {
      "title": "Create Automotive Ads for Models | TikTok API for Business",
      "description": "This article walks you through the steps to create Automotive Ads for Models. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825119056527362": {
      "title": "Get trending videos related to hashtags Overview",
      "description": "Use this endpoint to retrieve the top 20 trending videos that use a popular hashtag in the selected top country of the hashtag and timeframe."
    },
    "1739566528222210": {
      "title": "About Streaming API | TikTok API for Business",
      "description": "Streaming API is our real-time batch update tool designed to support high throughput needs of data partners and certain high-volume advertisers."
    },
    "1739381823123458": {
      "title": "API reference Overview | TikTok API for (Guide)",
      "description": "The following endpoints are available for campaign management. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"API."
    },
    "1740654203526146": {
      "title": "Create an identity Guide | TikTok API for Business",
      "description": "Use this endpoint to create a Custom User (`CUSTOMIZED_USER`) identity. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1767568466842626": {
      "title": "Get Creative Fatigue Detection results Documentation",
      "description": "Use this endpoint to detect whether Creative Fatigue occurred for an ad within a specified time range in the past."
    },
    "1797202997456897": {
      "title": "Delete creative assets | TikTok API for Business",
      "description": "Use this endpoint to delete your creative assets. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete creative."
    },
    "1759233576199169": {
      "title": "Get the available products in a Showcase Overview",
      "description": "Use this endpoint to get the Showcase products that can be used to target the specified country or region."
    },
    "1739473077112833": {
      "title": "Update Smart Creative materials | TikTok API for Business",
      "description": "Use this endpoint to modify Smart Creative ad creatives. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update."
    },
    "1739092028876801": {
      "title": "Create a subscription | TikTok API for Business",
      "description": "Use this endpoint to subscribe to ad account suspension status, leads, and more. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1769325280876545": {
      "title": "Add an URL property to an ad account Best Practices",
      "description": "Use this endpoint to add an URL property (domain or URL prefix) that you want to verify ownership of, to an advertiser account."
    },
    "1759155939236865": {
      "title": "Delete an identity Guide | TikTok API for Business",
      "description": "Use this endpoint to delete a customized user identity (`identity_type` = `CUSTOMIZED_USER`). In this guide, you'll learn what to do, when to use it, and what."
    },
    "1739092113671170": {
      "title": "Get a portfolio by ID | TikTok API for Business",
      "description": "Use this endpoint to get an existing creative portfolio by its ID. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1824036608950273": {
      "title": "Unity integration steps | TikTok API for Business",
      "description": "This article explains \"Unity integration steps\" and provides practical guidance for working with TikTok API for Business."
    },
    "1768493902119937": {
      "title": "Get, renew or revoke a Creator access token Guide",
      "description": "This article explains \"Get, renew or revoke a Creator access token\" and provides practical guidance for working with TikTok API for Business."
    },
    "1775548501843970": {
      "title": "Create Website Conversions ads | TikTok API for Business",
      "description": "This article walks you through the steps to create Website Conversions ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740564136678402": {
      "title": "Get products Overview | TikTok API for Business",
      "description": "Use this endpoint to get the list of products in your product catalog. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1777633230937090": {
      "title": "Create single image ads | TikTok API for Business",
      "description": "This article walks you through the steps to create single image ads on Pangle or Global App Bundle placement."
    },
    "1740665273039873": {
      "title": "(Deprecated) Create a video package Best Practices (Guide)",
      "description": "Use this endpoint to create a video package. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"(Deprecated) Create a."
    },
    "1739659520972802": {
      "title": "Manage a pixel Overview | TikTok API for Business",
      "description": "This article explains \"Manage a pixel\" and provides practical guidance for working with TikTok API for Business."
    },
    "1816387106635778": {
      "title": "Get the publishing status of a TikTok post Overview",
      "description": "Use this endpoint to obtain the publishing status of a TikTok video post or photo post. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1847461383861378": {
      "title": "API Service Status Page | TikTok API for Business",
      "description": "This article explains \"API Service Status Page\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740133053109249": {
      "title": "(Deprecated) Dynamic Scene | TikTok API for (Guide)",
      "description": "This article explains \"(Deprecated) Dynamic Scene\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740040139110466": {
      "title": "Update the Pangle block list | TikTok API for Business",
      "description": "Use this endpoint to update the Pangle block list. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update the."
    },
    "1739939020318721": {
      "title": "Create an ad account | TikTok API for Business",
      "description": "Use this endpoint to create an auction ad account in the **Agency** or **Direct** Business Center. In this guide, you'll learn what to do, when to use it, and."
    },
    "1782087855154177": {
      "title": "Optimize Destination visit in Video Shopping Ads",
      "description": "This article explains \"Optimize Destination visit in Video Shopping Ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1754705410074626": {
      "title": "Asset Groups Overview | TikTok API for Business",
      "description": "You (**Admin users of Agency Business Centers**) can use Business Center API to manage Asset Groups."
    },
    "1742666471475201": {
      "title": "Create a split test | TikTok API for Business",
      "description": "Use this endpoint to create a split test group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a split."
    },
    "1801524003169281": {
      "title": "Work with Single Page Applications Best Practices",
      "description": "This article explains \"Work with Single Page Applications\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739381246298114": {
      "title": "Budget Best Practices | TikTok API for Business",
      "description": "To give more control over your advertising cost, TikTok For Business supports budget settings at both campaign and ad group level."
    },
    "1740315452868610": {
      "title": "Get catalogs Overview | TikTok API for Business",
      "description": "Use this endpoint to get information about a catalog or all catalogs under a Business Center. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1745292439329793": {
      "title": "Targeting Documentation | TikTok API for Business",
      "description": "We provide various targeting options for you to pinpoint the exact audiences you want your ads to be displayed to."
    },
    "1740302379236353": {
      "title": "Estimate audience size | TikTok API for Business",
      "description": "Use this endpoint to get the estimated audience size. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Estimate."
    },
    "1825107985360898": {
      "title": "Get top 1000 comment mentions on posts Documentation",
      "description": "Use this endpoint to retrieve a list of up to 1,000 post comments or replies that mention a business's handle."
    },
    "1832184607786242": {
      "title": "Turn on or turn off an automatic message for a Business",
      "description": "Use this endpoint to turn on or turn off an automatic message setting for a Business Account. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1825108021550082": {
      "title": "Delete a Mentions Webhook configuration Overview",
      "description": "Use this endpoint to delete an existing configuration for Mentions Webhook events at the developer app level."
    },
    "1813772274039809": {
      "title": "Submit UnionPay verification for a business license",
      "description": "Use this endpoint to submit UnionPay verification for a business license. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739584860883969": {
      "title": "Set up TikTok Click ID and Cookies Best Practices",
      "description": "This article explains \"Set up TikTok Click ID and Cookies\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739049313198081": {
      "title": "Delete a test lead Guide | TikTok API for Business",
      "description": "Use this endpoint to delete an existing test lead. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete a test."
    },
    "1738811219460097": {
      "title": "Create a change log download task Best Practices",
      "description": "Use this endpoint to initiate a change log download task for an ad account based on the parameters that you specify."
    },
    "1759978341579777": {
      "title": "Webhook verification | TikTok API for Business",
      "description": "This topic outlines how to conduct webhook verification. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Webhook."
    },
    "1771100936446977": {
      "title": "Send TikTok Cookie (_ttp) | TikTok API for Business",
      "description": "This article explains \"Send TikTok Cookie (_ttp)\" and provides practical guidance for working with TikTok API for Business."
    },
    "1764231376750658": {
      "title": "SDK Best Practices | TikTok API for Business",
      "description": "The API for Business SDK is the ultimate solution for developers looking to streamline the integration process and enhance productivity."
    },
    "1843310536069122": {
      "title": "Ad Review Documentation | TikTok API for Business (Guide)",
      "description": "This article explains \"Ad Review\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738864835805186": {
      "title": "Report types Overview | TikTok API for Business",
      "description": "This article explains \"Report types\" and provides practical guidance for working with TikTok API for Business."
    },
    "1834189283112962": {
      "title": "Sales Best Practices | TikTok API for Business",
      "description": "Sales is an advertising campaign objective to drive sales on your TikTok Shop, website, or app. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740029179343874": {
      "title": "Account structure Guide | TikTok API for Business",
      "description": "A developer account can have up to 5 developer apps. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Account."
    },
    "1822000968821762": {
      "title": "Get the details of a GMV Max Campaign Documentation",
      "description": "Use this endpoint to retrieve the details of a GMV Max Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1745292231199745": {
      "title": "Campaign Documentation | TikTok API for Business",
      "description": "Campaigns are the highest level of advertising. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Campaign\"."
    },
    "1740491571747841": {
      "title": "Get locations and currencies | TikTok API for Business",
      "description": "This article explains \"Get locations and currencies\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738864498580481": {
      "title": "Business Center Guide | TikTok API for Business",
      "description": "You can use Business Center API to efficiently manage multiple TikTok ad accounts, users, assets, and finances."
    },
    "1774482992153601": {
      "title": "Create a Lead Generation ad with optimization (Overview)",
      "description": "This article introduces how to create a Lead Generation ad with optimization location as TikTok direct messages."
    },
    "1754263078057986": {
      "title": "Overview Documentation | TikTok API for (Tutorial)",
      "description": "A catalog is an asset that allows you to store information about the products you want to promote on TikTok."
    },
    "1782086241778690": {
      "title": "Optimize Destination Visit in Traffic ads Overview",
      "description": "This article explains \"Optimize Destination Visit in Traffic ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843317510389761": {
      "title": "Run an Upgraded Smart+ Creative Breakdown Report",
      "description": "Use this endpoint to retrieve an Upgraded Smart+ Creative Breakdown Report, a breakdown of the reporting data on creatives within Upgraded Smart+ Ads."
    },
    "1825113658431489": {
      "title": "Subscribe to mentions via Webhooks API Documentation",
      "description": "This guide walks you through the steps to receive notifications for mentions of your business in post captions or comments via Webhooks."
    },
    "1740649324143617": {
      "title": "API reference Overview | TikTok API for Business (Guide)",
      "description": "Creative APIs consist of the following endpoint groups: - Creative assets * [Creative portfolios](https://ads.tiktok.com/marketing_api/docs?"
    },
    "1854112742370306": {
      "title": "Compatibility changes for Upgraded Smart+ Campaigns",
      "description": "The following table outlines the compatibility changes for Upgraded Smart+ Campaigns in various endpoints."
    },
    "1832184145137922": {
      "title": "Access to Business Messaging API | TikTok API for Business",
      "description": "TikTok's Business Messaging API enables Business Accounts to send and receive direct messages with TikTok users on API-integrated platforms."
    },
    "1833997638479041": {
      "title": "Obtain a short-term access token | TikTok API for Business",
      "description": "Use this endpoint to obtain a short-term access token. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Obtain a."
    },
    "1799004081342466": {
      "title": "GTM container changes | TikTok API for Business",
      "description": "The following table outlines the tags, variables, and triggers created in your GTM (Google Tag Manager) account by the Events Manager interactive setup flow."
    },
    "1830112418755778": {
      "title": "Brand Safety Overview | TikTok API for Business",
      "description": "Brand Safety solutions are designed to keep the reputation of a brand safe when they advertise online."
    },
    "1832184497985537": {
      "title": "Delete a Business Messaging Webhook configuration",
      "description": "Use this endpoint to delete an existing configuration for Business Messaging Webhook events at the developer app level."
    },
    "1754000198430722": {
      "title": "Download synchronously | TikTok API for Business",
      "description": "Use this endpoint to download an individual invoice synchronously. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740317382510593": {
      "title": "(Deprecated) Run a report | TikTok API for Business",
      "description": "Use this endpoint to run a report of dynamic scene videos. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739318962329602": {
      "title": "Create a campaign Guide | TikTok API for Business (Guide)",
      "description": "Use this endpoint to create a campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a campaign\"."
    },
    "1740052650395650": {
      "title": "Upload a piece of music | TikTok API for Business",
      "description": "Use this endpoint to upload music and get the music ID, to add music to the Liked list or History list, or to remove music from the Liked list."
    },
    "1771101204435970": {
      "title": "Limited data use Guide | TikTok API for Business",
      "description": "This article explains \"Limited data use\" and provides practical guidance for working with TikTok API for Business."
    },
    "1746998678415361": {
      "title": "Manage audiences Guide | TikTok API for Business",
      "description": "This topic discusses how to manage your audiences, including getting, updating, deleting, sharing audiences, applying audiences to multiple ad groups, etc."
    },
    "1740317320231938": {
      "title": "(Deprecated) Create an async task Best Practices",
      "description": "Use this endpoint to create a task that generates videos. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1822001136924674": {
      "title": "Check the occupancy of identities or products in Shopping",
      "description": "This article explains \"Check the occupancy of identities or products in Shopping Ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1771101151059969": {
      "title": "Parameters Documentation | TikTok API for Business",
      "description": "This article explains \"Parameters\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738928364967937": {
      "title": "Concepts Documentation | TikTok API for Business",
      "description": "This article explains the concepts used throughout API For Business. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1842225078560769": {
      "title": "Custom Conversions Guide | TikTok API for Business",
      "description": "This article explains \"Custom Conversions\" and provides practical guidance for working with TikTok API for Business."
    },
    "1820826847199234": {
      "title": "Renew a TIP Editor SDK access token Best Practices",
      "description": "Use this endpoint to renew a TikTok Instant Page (TIP) Editor SDK access token. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1822106113771521": {
      "title": "Create a welcome message within an ad account Guide",
      "description": "Use this endpoint to create a welcome message in your ad account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740570556295169": {
      "title": "Get product sets Guide | TikTok API for Business",
      "description": "Use this endpoint to get a list of product sets or one specified product set in a catalog under your Business Center."
    },
    "1780799405041665": {
      "title": "Get catalog event source diagnostic information",
      "description": "Use this endpoint to retrieve diagnostic information for the event sources that are bound to your catalog."
    },
    "1825299591414850": {
      "title": "Get the MMM data request history | TikTok API for Business",
      "description": "Use this endpoint to retrieve the details of historical Media Mix Modeling (MMM) data requests. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739067422728193": {
      "title": "Images Best Practices | TikTok API for Business",
      "description": "Images can be divided into three categories: images to be used as ads, images as video covers, and profile images."
    },
    "1771101064635394": {
      "title": "FAQs Best Practices | TikTok API (Guide)",
      "description": "Q1: Is there any rate limit that we should be aware of? In this guide, you'll learn what to do, when to use it, and what to check when implementing \"FAQs\"."
    },
    "1739029260837889": {
      "title": "Get blocked words Guide | TikTok API for Business",
      "description": "Use this endpoint to get the list of blocked words for an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1763572749953025": {
      "title": "Overview Documentation | TikTok API for (Guide)",
      "description": "TikTok Store is an entity or object that allows a merchant to manage and sell products on TikTok. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739029247961089": {
      "title": "Check the statuses of words | TikTok API for Business",
      "description": "Use this endpoint to check if a list of words are blocked. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Check."
    },
    "1738957702411265": {
      "title": "Reply to a comment Guide | TikTok API for Business",
      "description": "Use this endpoint to reply to a comment. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Reply to a comment\"."
    },
    "1799004006287425": {
      "title": "Google Tag Manager (GTM) Integration Documentation",
      "description": "This article explains \"Google Tag Manager (GTM) Integration\" and provides practical guidance for working with TikTok API for Business."
    },
    "1765314260115458": {
      "title": "Smart+ Best Practices | TikTok API for Business",
      "description": "Smart+ Campaign is TikTok's AI-powered flagship automation solution to maximize your delivery outcomes with less effort from your side."
    },
    "1739314558673922": {
      "title": "Get ad groups Overview | TikTok API for Business",
      "description": "Use this endpoint to obtain detailed information of an ad group or ad groups. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1808164002093058": {
      "title": "Create Community Interaction ads | TikTok API for Business",
      "description": "This article walks you through the steps to create Community Interaction ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1843309514567809": {
      "title": "Create Upgraded Smart+ Web Campaigns Documentation",
      "description": "This article walks you through the steps to create Upgraded Smart+ Web Campaigns. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739506701165570": {
      "title": "Update the statuses of Smart Creative materials",
      "description": "Use this endpoint to update the status of creative materials for Smart Creative ads, including ad texts, images, and video materials."
    },
    "1854104036724929": {
      "title": "FAQs Best Practices | TikTok API for Business (Help)",
      "description": "Access and eligibility ## Q1: How can I determine if my ad account has access to Upgrade Smart+ Campaigns (the Upgraded Smart+ experience)?"
    },
    "1740245829978113": {
      "title": "Cancel the sharing of an audience Best Practices",
      "description": "Use this endpoint to stop the sharing of an audience with advertisers. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1771101186666498": {
      "title": "Supported events Guide | TikTok API for Business",
      "description": "Events are defined as actions a visitor takes to achieve a business goal, such as adding an item to a cart, filling out a form, or making a purchase."
    },
    "1739938996913218": {
      "title": "Upload a business certificate | TikTok API for Business",
      "description": "Use this endpoint to upload a business certificate. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload a."
    },
    "1853377803841537": {
      "title": "Create an Upgraded Smart+ DC App Campaign Overview",
      "description": "An Upgraded Smart+ DC App Campaign is an Upgraded Smart+ App Campaign with iOS 14 dedicated campaign setting enabled and without using a catalog."
    },
    "1832190670631937": {
      "title": "Subscribe to Business Messaging Webhook events via Webhooks",
      "description": "This article explains \"Subscribe to Business Messaging Webhook events via Webhooks API\" and provides practical guidance for working with TikTok API for."
    },
    "1765596741157889": {
      "title": "Update an Offline Event set | TikTok API for Business",
      "description": "Use this endpoint to update the name, the Auto Tracking setting, or both of an Offline Event set. In this guide, you'll learn what to do, when to use it, and."
    },
    "1785886237030401": {
      "title": "(To-be-deprecated) Create Product Shopping Ads Guide",
      "description": "This article walks you through the steps to create Product Shopping Ads (PSA). In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1766037914914818": {
      "title": "FAQs Best Practices | TikTok API for Business (Guide)",
      "description": "This article collects some common questions and error messages about authorization. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1758052897775617": {
      "title": "FAQs Best Practices | TikTok API (Tutorial)",
      "description": "**Q1: I see 40002 response code like the following instead of 200, what can I do?** A1: Make sure you are the admin or operator under this advertiser account."
    },
    "1739093832125442": {
      "title": "Get subscription details of a developer app Guide",
      "description": "Use this endpoint to get the subscription details of a developer app. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740029171730433": {
      "title": "Rate limits Overview | TikTok API for Business",
      "description": "To ensure service availability and performance, we have global and endpoint-specific rate limits. In this guide, you'll learn what to do, when to use it, and."
    },
    "1831359360477185": {
      "title": "Get the details of a mentioned post from mentions webhook",
      "description": "This article explains \"Get the details of a mentioned post from mentions webhook\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738864928947201": {
      "title": "Audience reports Guide | TikTok API for Business",
      "description": "Audience reports are a type of report from which you can get audience data, including age, gender, region, or interest."
    },
    "1822388944791617": {
      "title": "Get benchmarks for a business category Documentation",
      "description": "Use this endpoint to retrieve the benchmarks specific to a business category. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1843317465695233": {
      "title": "Get the review info of Upgraded Smart+ Ads Overview",
      "description": "Use this endpoint to retrieve the review results of Upgraded Smart+ Ads, including creatives within the ads."
    },
    "1739585704427522": {
      "title": "Work with CSP Overview | TikTok API for Business",
      "description": "This article explains \"Work with CSP\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739584805049345": {
      "title": "Events API : App Guide | TikTok API for Business",
      "description": "> <span style=\"color:DodgerBlue\">**Note**</span><br>Events API - App is currently in Beta. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1840137502583809": {
      "title": "Enable Value-Based Optimization in Smart+ Campaigns",
      "description": "This article walks you through the steps to enable Value-Based Optimization (VBO) in Smart+ Campaigns."
    },
    "1825105003772930": {
      "title": "Authentication Overview | TikTok API for (Tutorial)",
      "description": "This article explains \"Authentication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1854823717597185": {
      "title": "Messaging limits for Business Messaging API Guide",
      "description": "This article explains \"Messaging limits for Business Messaging API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1832184079395841": {
      "title": "Overview Documentation Guide | TikTok API for Business",
      "description": "Messaging is an integral part of how businesses manage their presence as well as doing business with users on social media platforms."
    },
    "1738857874837506": {
      "title": "Create an ad group Guide | TikTok API for Business",
      "description": "This article introduces how to create an ad group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an ad."
    },
    "1820826826000385": {
      "title": "Validate a TIP Editor SDK access token Documentation",
      "description": "Use this endpoint to verify whether a TikTok Instant Page (TIP) Editor SDK access token has expired."
    },
    "1832184403754242": {
      "title": "Send a message to a conversation | TikTok API for Business",
      "description": "Use this endpoint to send a message to a conversation. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Send a."
    },
    "1834560049625089": {
      "title": "Delete portfolios Guide | TikTok API for Business",
      "description": "Use this endpoint to bulk delete creative portfolios (interactive add-ons). In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739381757818881": {
      "title": "Campaign Budget Optimization | TikTok API for Business",
      "description": "Overview Campaign Budget Optimization (CBO) is a feature that enables advertisers to maximize campaign results by dynamically controlling the campaign budget."
    },
    "1779541971843073": {
      "title": "Deeplink Documentation | TikTok API for Business",
      "description": "Deeplinks are a feature that directs an user to a certain page within the promoted App, optimizing user journeys and improving ad performance."
    },
    "1759130033155073": {
      "title": "Check the names of files | TikTok API for Business",
      "description": "Use this endpoint to check whether one or more file names have been used for images or videos. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1799004110681154": {
      "title": "Set up events manually | TikTok API for Business",
      "description": "To set up TikTok events manually without using the data layer, you can use the template parameter override."
    },
    "1825108014565442": {
      "title": "Get a Mentions Webhook configuration Documentation",
      "description": "Use this endpoint to retrieve the existing configuration for Mentions Webhook events at the developer app level."
    },
    "1781891506567170": {
      "title": "Overview Documentation | TikTok API for Business (Guide)",
      "description": "TikTok Marketing API empowers businesses to fully optimize their advertising efforts with powerful tools and data insights."
    },
    "1843310518576130": {
      "title": "Campaigns Documentation | TikTok API for Business",
      "description": "Campaigns are the highest level of advertising. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Campaigns\"."
    },
    "1750361719059457": {
      "title": "(To-be-deprecated) Create Video Shopping Ads with products",
      "description": "This article explains \"(To-be-deprecated) Create Video Shopping Ads with products from TikTok Commerce\" and provides practical guidance for working with TikTok."
    },
    "1739583647070209": {
      "title": "Events API 1.0 Overview | TikTok API for Business",
      "description": "This article explains \"Events API 1.0\" and provides practical guidance for working with TikTok API for Business."
    },
    "1788434463507458": {
      "title": "Get the results of an asynchronous campaign copy task",
      "description": "Use this endpoint to check the results of an asynchronous campaign copy task. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1770092377990145": {
      "title": "Limited Data Use Guide | TikTok API for Business (Help)",
      "description": "This article explains \"Limited Data Use\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739381752981505": {
      "title": "Brand safety Overview | TikTok API for Business",
      "description": "Brand Safety solutions are designed to keep the reputation of a brand safe when they advertise online."
    },
    "1825017307843585": {
      "title": "Discover TTO creators | TikTok API for Business",
      "description": "Use this endpoint to search for TikTok One (TTO) creators. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1832184367408130": {
      "title": "Direct messages Guide | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Send a message to a conversation](https://business-api.tiktok.com/portal/docs?id=18321844."
    },
    "1825107519114241": {
      "title": "Appendix Documentation | TikTok API for Business",
      "description": "This article lists the enum values for some common fields used in Mentions API endpoints. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1754705308039169": {
      "title": "BC creation Overview | TikTok API for Business",
      "description": "Creating a TikTok Business Center will allow you to manage your TikTok ad accounts between multiple users in a secure and centralized environment."
    },
    "1780154619404290": {
      "title": "Get details of Saved Audiences | TikTok API for Business",
      "description": "Use this endpoint to get the details of Saved Audiences associated with an ad account. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1767309272869890": {
      "title": "FAQs Best Practices | TikTok API for (Guide)",
      "description": "This article summarizes FAQs about the Campaign Management API. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739585434183746": {
      "title": "Android integration steps | TikTok API for Business",
      "description": "This article explains \"Android integration steps\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738963942132738": {
      "title": "(Deprecated) Create Collection ads Best Practices",
      "description": "This article explains \"(Deprecated) Create Collection ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1835246967275522": {
      "title": "Create a max delivery or creative boost session",
      "description": "Use this endpoint to create a max delivery session for a specific product or a creative boost session for a specific video in a Product GMV Max Campaign."
    },
    "1759238111603713": {
      "title": "TikTok’s Anti-Discrimination Ad Policy Documentation",
      "description": "All businesses advertising on TikTok must comply with our anti-discrimination policy. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1853377811982657": {
      "title": "Create an Upgraded Smart+ Minis Campaign Overview",
      "description": "This article walks you through the steps to create an Upgraded Smart+ Minis Campaign. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739939128198145": {
      "title": "Get the balance of a BC | TikTok API for Business",
      "description": "Use this endpoint to obtain the balance of a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1769113255352322": {
      "title": "Comments Documentation | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Get comments on an owned video](https://ads.tiktok.com/marketing_api/docs?id=176023210961."
    },
    "1762962378261506": {
      "title": "Get internet service providers | TikTok API for Business",
      "description": "Use this endpoint to get targeting tags. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get internet service."
    },
    "1825119063013505": {
      "title": "Get popular tracks from the Commercial Music Library",
      "description": "This article explains \"Get popular tracks from the Commercial Music Library\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739940570793985": {
      "title": "Create an audience by file | TikTok API for Business",
      "description": "Use this endpoint to create an audience by file. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1825103730490434": {
      "title": "Authorization Overview | TikTok API for (Overview)",
      "description": "Before you use the Accounts API, you (the developer) need to first get authorization from the business to manage their accounts."
    },
    "1780154666312706": {
      "title": "Delete Saved Audiences | TikTok API for Business",
      "description": "Use this endpoint to delete Saved Audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete Saved."
    },
    "1832184277518338": {
      "title": "Manage the suggested questions for a Business Account",
      "description": "This article walks you through the steps for managing the suggested questions for a Business Account using Business Messaging API."
    },
    "1803654904260674": {
      "title": "Upload catalog videos to associate with catalog products",
      "description": "Uploaded catalog videos are a feature that allows you to associate a video with multiple products in your E-commerce catalog."
    },
    "1803073899092993": {
      "title": "Supported dimensions | TikTok API for (Guide)",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1825108008121346": {
      "title": "Create a Mentions Webhook configuration Overview",
      "description": "Use this endpoint to create the configuration for Mentions events related to your TikTok account at the developer app level."
    },
    "1739585700402178": {
      "title": "Advanced Matching Guide | TikTok API for Business",
      "description": "About Advanced Matching Advanced Matching helps you optimize your TikTok ads and drive performance by matching customer information with people on TikTok."
    },
    "1837161048383489": {
      "title": "Migrate to GMV Max Campaigns | TikTok API for Business",
      "description": "This article explains \"Migrate to GMV Max Campaigns\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739067433456642": {
      "title": "Upload an image Guide | TikTok API for Business (Guide)",
      "description": "Use this endpoint to upload pictures to the Asset Library and use the obtained image ID for creating ads."
    },
    "1739094758789122": {
      "title": "Cancel a subscription | TikTok API for Business",
      "description": "Use this endpoint to cancel a subscription. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Cancel a subscription\"."
    },
    "1832184175482945": {
      "title": "Authentication Overview | TikTok API for (Guide)",
      "description": "This article explains \"Authentication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1770118680584194": {
      "title": "Get qualifications within a Business Center Guide",
      "description": "Use this endpoint to retrieve existing qualifications within a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1830335387914241": {
      "title": "Create a Brand Profile for your TTO account Guide",
      "description": "Use this endpoint to create a Brand Profile for your TikTok One (TTO) Creator Marketplace account. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739940398505986": {
      "title": "Audience Documentation | TikTok API for Business",
      "description": "Audience is an ad targeting option that enables TikTok For Business advertisers to target or exclude specific users when setting up ads."
    },
    "1815051801257986": {
      "title": "Get the authorization status of a TikTok post Guide",
      "description": "Use this endpoint to get the authorization status of a TikTok post. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739939482851329": {
      "title": "Delete a member from a BC or revoke a member invitation",
      "description": "Use this endpoint to delete a member in a Business Center or revoke a member invitation. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1810521709205505": {
      "title": "Webhook subscription | TikTok API for Business",
      "description": "This chapter consists of the following use cases: - [Subscribe to TikTok account Webhook events via Webhooks API](https://business-api.tikto."
    },
    "1752256248260610": {
      "title": "Dedicated Campaign quota limits | TikTok API for Business",
      "description": "By default, Dedicated Campaigns are all SKAN Dedicated Campaigns and the campaign is bound by Dedicated Campaign quota rules."
    },
    "1822000911166465": {
      "title": "GMV Max Best Practices | TikTok API for Business",
      "description": "GMV Max is an automated ad campaign type that optimizes total channel ROI for your TikTok Shop. In this guide, you'll learn what to do, when to use it, and."
    },
    "1835246996436162": {
      "title": "Get max delivery or creative boost sessions within a",
      "description": "Use this endpoint to retrieve all active max delivery sessions for products or creative boost sessions for videos within a Product GMV Max Campaign."
    },
    "1762228503821314": {
      "title": "Get recommended hashtags for TikTok accounts Guide",
      "description": "Use this endpoint to specify a keyword and get a list of recommended hashtags to be used for your TikTok account videos."
    },
    "1816372654109698": {
      "title": "Get TTO creator ranking or search labels Overview",
      "description": "Use this endpoint to retrieve the creator industry or content tag labels associated with TikTok One (TTO) creators."
    },
    "1740306544966657": {
      "title": "Update the name of a catalog | TikTok API for Business",
      "description": "Use this endpoint to update the name of a catalog. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update the name."
    },
    "1740562489236481": {
      "title": "Remove products Guide | TikTok API for Business",
      "description": "Use this endpoint to delete products in bulk. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Remove products\"."
    },
    "1825107971247170": {
      "title": "Get frequent keywords used in top 1000 mentioned posts",
      "description": "Use this endpoint to retrieve the top 20 keywords in the captions of mentioned posts. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740295904843777": {
      "title": "Get the unpaid amount of a BC | TikTok API for Business",
      "description": "Use this endpoint to get total unpaid amount of your Business Center account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1832184470423554": {
      "title": "Create a Business Messaging Webhook configuration",
      "description": "Use this endpoint to create the configurations for Business Messaging Webhook events at the developer app level."
    },
    "1797016417934337": {
      "title": "Audience Insights Guide | TikTok API for Business",
      "description": "This article explains \"Audience Insights\" and provides practical guidance for working with TikTok API for Business."
    },
    "1855026897423361": {
      "title": "Organization Account | TikTok API for Business",
      "description": "This guide explains what Organization Accounts are, their benefits, and how they fit into your workflow."
    },
    "1739047069984834": {
      "title": "Leads Best Practices | TikTok API for Business",
      "description": "Lead generation is the process of identifying and cultivating potential customers for a business's products or services."
    },
    "1740295923474433": {
      "title": "Download the invoices of a BC | TikTok API for Business",
      "description": "Use these endpoints to download invoices, via synchronous downloads or asynchronous downloads. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1738864739862530": {
      "title": "Reporting Documentation | TikTok API for Business (Help)",
      "description": "You can use Reporting API to run a report on your auction ads and reservation ads data, in synchronous mode or asynchronous mode."
    },
    "1842232769643905": {
      "title": "Create Smart+ Catalog Ads with Website and App Optimization",
      "description": "This article walks you through the steps to create Smart+ Catalog Ads with Website and App Optimization."
    },
    "1822001084174338": {
      "title": "Check the availability of a TikTok Shop for Product GMV Max",
      "description": "This article explains \"Check the availability of a TikTok Shop for Product GMV Max Campaigns\" and provides practical guidance for working with TikTok API for."
    },
    "1832184425841170": {
      "title": "Get a list of messages | TikTok API for Business",
      "description": "Use this endpoint to get a list of messages in a conversation. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1740049987749890": {
      "title": "Update the name of a video | TikTok API for Business",
      "description": "Use this endpoint to update the name of a video. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update the name."
    },
    "1758427576470529": {
      "title": "Create an Offline Event set | TikTok API for Business",
      "description": "Use this endpoint to create a new Offline Event set. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1835247031331842": {
      "title": "Get details of max delivery or creative boost sessions",
      "description": "Use this endpoint to retrieve the details of max delivery or creative boost sessions for a list of given session IDs."
    },
    "1739381236849665": {
      "title": "Audience targeting Guide | TikTok API for Business",
      "description": "You can use the following targeting options to target a specific audience. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1775104902283266": {
      "title": "Update a negative keyword | TikTok API for Business",
      "description": "Use this endpoint to update a negative keyword for Search Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1759978319341570": {
      "title": "Webhook event types | TikTok API for Business",
      "description": "TikTok offers two main categories of Webhook events related to TikTok accounts: - Post publishing events."
    },
    "1825127388184577": {
      "title": "Discovery API Overview | TikTok API for Business",
      "description": "This article explains \"Discovery API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1751617884206210": {
      "title": "Supported filters Guide | TikTok API for Business (Help)",
      "description": "You can use the following filters to narrow down the scope of reporting results. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739584809311234": {
      "title": "Events API : Web Guide | TikTok API for Business",
      "description": "This section introduces how to manage web events through Events API. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739665513181185": {
      "title": "User Best Practices | TikTok API for Business",
      "description": "Get user information Use this endpoint to obtain information about users who are authorized to access the developer App."
    },
    "1739351979503618": {
      "title": "(Deprecated) Get the status of a task Documentation",
      "description": "This article explains \"(Deprecated) Get the status of a task\" and provides practical guidance for working with TikTok API for Business."
    },
    "1830112550443073": {
      "title": "Get the Brand Safety Hub settings of an ad account",
      "description": "Use this endpoint to retrieve the Brand Safety Hub settings of an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825299584678017": {
      "title": "Obtain the download URL for MMM data Documentation",
      "description": "Use this endpoint to obtain the download URL for Media Mix Modeling (MMM) data. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740302808815618": {
      "title": "Download the output of an async report task Guide",
      "description": "Use this endpoint to download the output of the report after an asynchronous report task has completed."
    },
    "1853452461203458": {
      "title": "Upgraded Smart+ Campaign | TikTok API for Business",
      "description": "The Upgraded Smart+ Campaigns feature a new, unified workflow, known as the Upgraded Smart+ experience."
    },
    "1768463039162369": {
      "title": "Get the dynamic quota on active ad groups Overview",
      "description": "Use this endpoint to get the dynamic quota on the number of active auction ad groups that an advertiser can have."
    },
    "1780164603696130": {
      "title": "Create Search Ads Guide | TikTok API for Business",
      "description": "This article walks you through the steps to create Search Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738864940608513": {
      "title": "Playable ad reports | TikTok API for Business",
      "description": "Playable ad reports are a type of report from which you can get data about playable creatives. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740053909509122": {
      "title": "Get the music list Guide | TikTok API for Business",
      "description": "Use this endpoint to get the list of available music that can be used for video creation or Carousel Ads creation."
    },
    "1785880454546433": {
      "title": "Promote campaign Guide | TikTok API for Business",
      "description": "This article explains \"Promote campaign\" and provides practical guidance for working with TikTok API for Business."
    },
    "1746998266963969": {
      "title": "Overview Documentation | TikTok API (Guide)",
      "description": "This section introduces Audience Management API and its benefits. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1770091656601602": {
      "title": "Limited Data Use Guide | TikTok API for Business",
      "description": "This article explains \"Limited Data Use\" and provides practical guidance for working with TikTok API for Business."
    },
    "1785238052792321": {
      "title": "Get live videos under an identity Best Practices",
      "description": "Use this endpoint to get live videos under an identity. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get live."
    },
    "1739939106470913": {
      "title": "Get the balance and budget of ad accounts Overview",
      "description": "Use this endpoint to obtain the balance of ad accounts in the Business Center. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1774482999036930": {
      "title": "Create a Lead Generation ad with optimization (Tutorial)",
      "description": "This article introduces how to create a Lead Generation ad with optimization location as instant messaging apps."
    },
    "1739472835319809": {
      "title": "Smart Creative Overview | TikTok API for Business (Guide)",
      "description": "Smart Creative is a TikTok automated creative solution that optimizes ad creative combinations through ad group fatigue detection and auto-refresh strategies."
    },
    "1759239462689793": {
      "title": "Supported metrics for a dimension in basic reports",
      "description": "See the tables below to learn about the supported metrics when you use a dimension in basic reports."
    },
    "1822001200356354": {
      "title": "Grant an ad account exclusive authorization for a TikTok",
      "description": "Use this endpoint to authorize an ad account to create GMV Max Campaigns for a specific TikTok Shop."
    },
    "1807346079965186": {
      "title": "Work with Payload Helper for Web | TikTok API for Business",
      "description": "This article walks you through the steps of using the Payload Helper for Web to construct your payload for reporting Web Events using Events API 2.0."
    },
    "1739585432134657": {
      "title": "iOS integration steps | TikTok API for Business",
      "description": "This article explains \"iOS integration steps\" and provides practical guidance for working with TikTok API for Business."
    },
    "1774482936048641": {
      "title": "Create a Lead Generation ad with optimization (Help)",
      "description": "This article introduces how to create a Lead Generation ad with optimization location as phone call."
    },
    "1754263100123137": {
      "title": "Guides Best Practices | TikTok API for Business (Overview)",
      "description": "This guide walks you through how to create and manage catalogs as well as some catalog related use cases."
    },
    "1738957772267522": {
      "title": "Delete a comment Guide | TikTok API for Business",
      "description": "Use this endpoint to delete a comment. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete a comment\"."
    },
    "1820767460168705": {
      "title": "Get the activity log of a Business Center Overview",
      "description": "Use this endpoint to get the activity log of Business Centers. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1738864971714562": {
      "title": "(Deprecated) Reservation ad reports Best Practices",
      "description": "This article explains \"(Deprecated) Reservation ad reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740302781443073": {
      "title": "Get the status of an async report task Documentation",
      "description": "Use this endpoint to check the status of an asynchronous report task. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1769738074686465": {
      "title": "Get available content exclusion categories Overview",
      "description": "This article explains \"Get available content exclusion categories\" and provides practical guidance for working with TikTok API for Business."
    },
    "1822001044479041": {
      "title": "Get TikTok Shops for GMV Max Campaigns Documentation",
      "description": "Use this endpoint to obtain a list of TikTok Shops that an ad account has access to and whether the TikTok Shops can be used to create GMV Max Campaigns."
    },
    "1739924165710849": {
      "title": "Get the downloaded file | TikTok API for Business",
      "description": "Use this endpoint to download the change log file. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get the."
    },
    "1739583650172929": {
      "title": "TikTok App Events SDK | TikTok API for Business",
      "description": "This article explains \"TikTok App Events SDK\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739940501023746": {
      "title": "Customer File Overview | TikTok API for Business",
      "description": "Customer File API is a file-based API that can be used to build your target custom audience from uploaded data."
    },
    "1771101001228290": {
      "title": "FAQs Best Practices | TikTok API for (Tutorial)",
      "description": "Q1: I see a 40001 response code like the following instead of 0. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1754705315233793": {
      "title": "Members and partners | TikTok API for Business",
      "description": "You (**Admin users of a Business Center**) can use Business Center API to add people to your Business Center and assign them roles to manage your assets."
    },
    "1832184236919810": {
      "title": "Manage direct messages for a Business Account Guide",
      "description": "This article explains \"Manage direct messages for a Business Account\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825107955294402": {
      "title": "Get top 1000 mentioned posts | TikTok API for Business",
      "description": "Use this endpoint to retrieve a list of up to 1,000 posts that mention a Business Account in the post caption."
    },
    "1816986081880065": {
      "title": "CTM Events Documentation | TikTok API for Business",
      "description": "This article explains \"CTM Events\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740051189071873": {
      "title": "Get suggested thumbnails for a video Documentation",
      "description": "Use this endpoint to get a list of suggested video thumbnails based on a video creative. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1747849403155521": {
      "title": "Postman collection Guide | TikTok API for Business",
      "description": "We provide a Postman collection for our API endpoints. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Postman."
    },
    "1825119047070721": {
      "title": "Get details of a popular hashtag | TikTok API for Business",
      "description": "Use this endpoint to get detailed information about a popular hashtag, such as audience insights and hashtag status."
    },
    "1751454103714818": {
      "title": "Supported dimensions | TikTok API for Business (Guide)",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1751454162042882": {
      "title": "Supported metrics Guide | TikTok API for Business (Guide)",
      "description": "You can use the following metrics in audience reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1854103649826817": {
      "title": "Retrieve data for Upgrade Smart+, Smart+, and Manual",
      "description": "This article explains \"Retrieve data for Upgrade Smart+, Smart+, and Manual Campaigns\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825299463225345": {
      "title": "Media Mix Modeling Guide | TikTok API for Business",
      "description": "This article explains \"Media Mix Modeling\" and provides practical guidance for working with TikTok API for Business."
    },
    "1822106064917506": {
      "title": "Welcome Messages Guide | TikTok API for Business",
      "description": "Welcome messages are messages that are automatically sent to welcome people to the conversation after they tap on your ad."
    },
    "1740859196043266": {
      "title": "Report an App Event | TikTok API for Business",
      "description": "Use this endpoint to report a mobile (i.e. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Report an App Event\"."
    },
    "1825128519531521": {
      "title": "Rate limits for Spark Ads Recommendation API Guide",
      "description": "Global rate limits are applicable to Spark Ads Recommendation API endpoints. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1747553507237889": {
      "title": "Website conversions | TikTok API for Business",
      "description": "With the Website conversions objective, you can drive conversions on your website or TikTok Instant Page."
    },
    "1842225206555074": {
      "title": "Get the details of a Custom Conversion Documentation",
      "description": "Use this endpoint to retrieve the details of a Custom Conversion associated with a Pixel or an App. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739953405142018": {
      "title": "Update ads Documentation | TikTok API for Business",
      "description": "Use this endpoint to modify the creatives of your regular ads such as call-to-action, ad name, text, image and video material."
    },
    "1833862470219842": {
      "title": "Get valid brand mention hashtags for a Business Account",
      "description": "Use this endpoint to retrieve a list of valid hashtags that you can enable for a Business Account. In this guide, you'll learn what to do, when to use it, and."
    },
    "1738864894606337": {
      "title": "Data latency for reports | TikTok API for Business",
      "description": "There might be a latency for data fields in our reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Data."
    },
    "1746463695763458": {
      "title": "(To-be-deprecated) Get recommended budgets Overview",
      "description": "> <span style=\"color:DarkRed\">**Important**</span><br> > This endpoint will be deprecated in the next API version."
    },
    "1740665368159233": {
      "title": "(Deprecated) Preview video templates Documentation",
      "description": "Use this endpoint to preview video templates. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"(Deprecated) Preview."
    },
    "1771101130925058": {
      "title": "Authentication Overview | TikTok API for Business (Help)",
      "description": "To authenticate Events API 2.0 calls, you need an access token. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739067004677122": {
      "title": "(Deprecated) Callback request details Documentation",
      "description": "This article explains \"(Deprecated) Callback request details\" and provides practical guidance for working with TikTok API for Business."
    },
    "1806817505894402": {
      "title": "Export leads and postback CRM events Documentation",
      "description": "This article walks you through the steps to export leads and postback CRM (Customer Relationship Management) events as CRM partners."
    },
    "1843317522553106": {
      "title": "Appeal rejection of an Upgraded Smart+ Ad Overview",
      "description": "This article explains \"Appeal rejection of an Upgraded Smart+ Ad\" and provides practical guidance for working with TikTok API for Business."
    },
    "1803655037415489": {
      "title": "Upload catalog videos via a file URL Documentation",
      "description": "Use this endpoint to upload catalog videos via a file URL. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload."
    },
    "1832184291198977": {
      "title": "Manage the chat prompts for a Business Account Guide",
      "description": "This article walks you through the steps for managing the chat prompts for a Business Account using Business Messaging API."
    },
    "1762228399168514": {
      "title": "Get profile data of a TikTok account Documentation",
      "description": "Use this endpoint to access detailed analytics and insights about a TikTok account's follower base and profile engagement."
    },
    "1742666215544834": {
      "title": "Super Split Test Guide | TikTok API for Business (Guide)",
      "description": "This article explains \"Super Split Test\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740490222539778": {
      "title": "Migrate a catalog to a BC | TikTok API for Business",
      "description": "Use this endpoint to migrate a catalog under your ad account to your Business Center. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739659558931458": {
      "title": "Get members by an asset | TikTok API for Business",
      "description": "Use this endpoint to get members that have access to an asset. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1765942670613506": {
      "title": "Set up External ID Guide | TikTok API for Business (Guide)",
      "description": "External ID is an identifier that represents an user on an advertiser’s platform, such as a customer ID, loyalty card number or order ID."
    },
    "1806817494948930": {
      "title": "Obtain leads as advertisers | TikTok API for Business",
      "description": "This article walks you through the steps to obtain leads from the Lead Generation campaign as advertisers."
    },
    "1766217791987713": {
      "title": "Create Carousel Ads | TikTok API for Business",
      "description": "This article walks you through the steps to create Carousel Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1749001658583105": {
      "title": "Create an Asset Group | TikTok API for Business",
      "description": "Use this endpoint to create an Asset Group in your Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1832184415059970": {
      "title": "Get a list of conversations | TikTok API for Business",
      "description": "Use this endpoint to get a list of conversations. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get a list of."
    },
    "1773192725768193": {
      "title": "Share creative assets | TikTok API for Business",
      "description": "Use this endpoint to share existing creative assets under an advertiser account with other advertiser accounts."
    },
    "1739663268166722": {
      "title": "Get partners by an asset | TikTok API for Business",
      "description": "Use this endpoint to get the partners that you have shared a particular asset with. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1832112833212434": {
      "title": "Get an Instant Form lead or a direct message lead",
      "description": "Use this endpoint to retrieve an Instant Form lead or a direct message lead. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739432636922882": {
      "title": "BC Assets Documentation | TikTok API for Business",
      "description": "This article explains \"BC Assets\" and provides practical guidance for working with TikTok API for Business."
    },
    "1758428053652482": {
      "title": "Report Offline Events in bulk | TikTok API for Business",
      "description": "Use this endpoint to report offline events in bulk to reduce traffic to the TikTok API for Business."
    },
    "1826564985760770": {
      "title": "Delete a draft anchor | TikTok API for Business",
      "description": "Use this endpoint to delete an anchor in draft mode that was created on the [TikTok One](https://ads.tiktok.com/creative) platform."
    },
    "1739470742024193": {
      "title": "Create Lead Generation ads | TikTok API for Business",
      "description": "This article walks you through the steps to create Lead Generation ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740132953884673": {
      "title": "Catalog Product Sets | TikTok API for Business",
      "description": "This article explains \"Catalog Product Sets\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739381695768577": {
      "title": "Guides Best Practices | TikTok API for Business (Help)",
      "description": "These guides will walk you through the steps to complete common tasks for managing your campaigns, ad groups, and ads."
    },
    "1805437148769281": {
      "title": "Realtime API Overview | TikTok API for Business",
      "description": "This article introduces how to enable Realtime API (RTA) for your ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1746998681953281": {
      "title": "FAQs Best Practices | TikTok API for (Overview)",
      "description": "This article summarizes FAQs about the Audience Management API. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1842225174460673": {
      "title": "Get Custom Conversions associated with an event source",
      "description": "Use this endpoint to retrieve the Custom Conversions associated with a Pixel or an App. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1815693562720258": {
      "title": "Get TTO Creator Marketplace campaigns Documentation",
      "description": "Use this endpoint to retrieve the information of TikTok One (TTO) Creator Marketplace campaigns. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739091185604609": {
      "title": "Subscription Overview | TikTok API for Business",
      "description": "Subscription API enables you to subscribe to ad account suspension status, leads, and more, get the details of a subscription, or cancel a subscription."
    },
    "1741469487859714": {
      "title": "Get the results of a Smart Fix task Best Practices",
      "description": "Use this endpoint to get the results of a Smart Fix task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get the."
    },
    "1762405483224065": {
      "title": "Supported metrics for a dimension in playable ad reports",
      "description": "See the tables below to learn about the supported metrics when you use a dimension in playable ad reports."
    },
    "1855027199571138": {
      "title": "Create an Organization Account in a Business Center",
      "description": "Use this endpoint to create an Organization Account in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1832184455450626": {
      "title": "Download an image or a video from a message Guide",
      "description": "Use this endpoint to download an image or a video from a message. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1824048384831554": {
      "title": "Resources for data sharing after user consent Guide",
      "description": "This article explains \"Resources for data sharing after user consent\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740665161957377": {
      "title": "Create a feed Overview | TikTok API for Business",
      "description": "Use this endpoint to create a feed. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a feed\"."
    },
    "1758427539356673": {
      "title": "Offline Events Overview | TikTok API for Business",
      "description": "This article explains \"Offline Events\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740218420781057": {
      "title": "Get the identity list | TikTok API for Business",
      "description": "Use this endpoint to get a list of identities under an ad account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1830336456075458": {
      "title": "Brand Profile industry IDs | TikTok API for Business",
      "description": "This article explains \"Brand Profile industry IDs\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825107469360130": {
      "title": "FAQs Best Practices | TikTok (Tutorial)",
      "description": "This article summarizes FAQs about the Mentions API. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"FAQs\"."
    },
    "1739953422970882": {
      "title": "Update the statuses of ads | TikTok API for Business",
      "description": "Use this endpoint to enable, disable or delete an ad or ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738824477276162": {
      "title": "Creative Insights Guide | TikTok API for Business",
      "description": "Use this group of endpoints to get the performance data of ads against benchmarks and in-second performance data."
    },
    "1740574099715073": {
      "title": "Get video packages Guide | TikTok API for Business",
      "description": "Use this endpoint to get information about all catalog video packages, or a particular video package, under your Business Center."
    },
    "1771117232728066": {
      "title": "Get synchronous catalog product diagnostic information",
      "description": "Use this endpoint to retrieve diagnostic information synchronously for your catalog products. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1738963828459521": {
      "title": "Upload videos, images and music | TikTok API for Business",
      "description": "This article explains \"Upload videos, images and music\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843337879988226": {
      "title": "Supported dimensions for Upgraded Smart+ Creative Breakdown",
      "description": "Dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1832112377641026": {
      "title": "Get fields of an Instant Form or direct message leads",
      "description": "Use this endpoint to retrieve the fields of an Instant Form or direct message leads. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1754000504437762": {
      "title": "Get asynchronous download task list Best Practices",
      "description": "Use this endpoint to get `BILLING_REPORT`, `INVOICE_LIST` and `INVOICE_BATCH` tasks. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740039957181441": {
      "title": "Get the Pangle block list | TikTok API for Business",
      "description": "Use this endpoint to get the Pangle block list of an ad account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1832184596566017": {
      "title": "Update the automatic message for a Business Account",
      "description": "Use this endpoint to update an automatic message for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1837247744649345": {
      "title": "Approve or reject a TTO video linking request as a creator",
      "description": "Use this endpoint to approve or reject a request for linking your public video to a TikTok One (TTO) Creator Marketplace campaign."
    },
    "1827752507854850": {
      "title": "Create Automotive Ads for Inventory Best Practices",
      "description": "This article walks you through the steps to create Automotive Ads for Inventory. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1771100815832065": {
      "title": "Events API for Offline | TikTok API for Business",
      "description": "This article explains \"Events API for Offline\" and provides practical guidance for working with TikTok API for Business."
    },
    "1797023590780930": {
      "title": "Get details of audience overlap | TikTok API for Business",
      "description": "Use this endpoint to get the details of the audience overlap between the benchmark audience and up to four other TikTok Custom Audience segments."
    },
    "1825117808886785": {
      "title": "Get started for TTO API | TikTok API for Business",
      "description": "With developers in mind, we make accessing and using our API possible through only a few steps. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740302766489602": {
      "title": "Create an asynchronous report task Best Practices",
      "description": "Use this endpoint to create an asynchronous report task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1780896481480706": {
      "title": "CRM Events Documentation | TikTok API for Business",
      "description": "This article explains \"CRM Events\" and provides practical guidance for working with TikTok API for Business."
    },
    "1820826755283969": {
      "title": "Create a TIP Editor SDK access token Documentation",
      "description": "Use this endpoint to create a TikTok Instant Page (TIP) Editor SDK access token. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1781891830241281": {
      "title": "Get started Overview | TikTok API for Business",
      "description": "Welcome to Marketing API! In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get started\"."
    },
    "1747747118654465": {
      "title": "Get available contextual tags | TikTok API for Business",
      "description": "Use this endpoint to get the contextual tags that you can target. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738864778664961": {
      "title": "Run a synchronous report | TikTok API for Business",
      "description": "You can run a synchronous report to get data in real time. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Run a."
    },
    "1740578661644289": {
      "title": "Timelines Documentation | TikTok API for Business",
      "description": "The table below lists the specific deprecation dates for each version. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739048460493826": {
      "title": "Get a test lead Guide | TikTok API for Business",
      "description": "Use this endpoint to get a test lead. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get a test lead\"."
    },
    "1835052338764993": {
      "title": "Setup guide for CRM | TikTok API for Business",
      "description": "Get Started This guide walks you through the process of setting up Events API 2.0 for CRM (Customer relationship management)."
    },
    "1835087586303106": {
      "title": "Self-Host setup guide | TikTok API for Business",
      "description": "Prerequisites 1. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Self-Host setup guide\"."
    },
    "1738864850353154": {
      "title": "FAQs Best Practices | TikTok API for (Best Practices)",
      "description": "This article summarizes FAQs about the Reporting API. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"FAQs\"."
    },
    "1803654722508866": {
      "title": "Catalog Videos Overview | TikTok API for Business",
      "description": "This article explains \"Catalog Videos\" and provides practical guidance for working with TikTok API for Business."
    },
    "1771100952291330": {
      "title": "Set up External ID Guide | TikTok API for Business",
      "description": "External ID is an identifier that represents an user on an advertiser’s platform, such as a customer ID, loyalty card number or order ID."
    },
    "1815394136739841": {
      "title": "Create Search Ads Campaigns | TikTok API for Business",
      "description": "This article walks you through the steps to create Search Ads Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1751625287345154": {
      "title": "Supported dimensions | TikTok API for Business (Tutorial)",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1830335437705217": {
      "title": "Get the Brand Profiles for your TTO account Guide",
      "description": "Use this endpoint to retrieve the existing Brand Profiles for your TikTok One (TTO) Creator Marketplace account."
    },
    "1751098935842817": {
      "title": "Get the authorization status | TikTok API for Business",
      "description": "Use this endpoint to get the Spark Ads authorization status of a TikTok Creator Marketplace (TTCM) order or a TikTok One (TTO) Creator Marketplace campaign."
    },
    "1837799887531010": {
      "title": "Check TTO Creator Status | TikTok API for Business",
      "description": "Use this endpoint to check if TikTok users have already become TikTok One (TTO) Creators. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1848048566169730": {
      "title": "Migrate to Spark Ads | TikTok API for Business",
      "description": "This article explains \"Migrate to Spark Ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1771101027431425": {
      "title": "Setup guide for Offline | TikTok API for Business",
      "description": "Get Started This guide walks you through the process of setting up Events API 2.0 for Offline. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1739289524101122": {
      "title": "Lead generation Guide | TikTok API for Business",
      "description": "This chapter consists of the following use cases: - [Obtain leads as advertisers](https://business-api.tiktok.com/portal/docs?id=18068174949."
    },
    "1740132866693122": {
      "title": "Catalog Management Guide | TikTok API for Business (Guide)",
      "description": "This article explains \"Catalog Management\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739355078757377": {
      "title": "(Deprecated) Create a Quick Optimization task Guide",
      "description": "Use this endpoint to create a video optimization task, which is mainly about HORIZONTAL to VERTICAL transformation now."
    },
    "1739657251102722": {
      "title": "Delete assets from a BC | TikTok API for Business",
      "description": "Use this endpoint to delete assets from a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete."
    },
    "1749819614433282": {
      "title": "Set up Advanced Matching | TikTok API for Business",
      "description": "This guide is intended for implementing Advanced Matching with the TikTok Events API. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1822001101474882": {
      "title": "Get identities for GMV Max Campaigns Documentation",
      "description": "Use this endpoint to obtain a list of identities that are associated with a TikTok Shop and whether the identities are available for GMV Max Campaigns."
    },
    "1740572891104257": {
      "title": "Create a product set by conditions Best Practices",
      "description": "Use this endpoint to create a product set by conditions in a catalog under your Business Center. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740665197662210": {
      "title": "Update a feed Overview | TikTok API for Business",
      "description": "Use this endpoint to update a feed. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update a feed\"."
    },
    "1775099621140482": {
      "title": "Optimize Landing page view in Video Shopping Ads",
      "description": "This article walks you through the steps to use the optimization goal Landing page view in Video Shopping Ads."
    },
    "1739585574120449": {
      "title": "Supported app events | TikTok API for Business",
      "description": "This article explains \"Supported app events\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843324592169986": {
      "title": "Create an Upgraded Smart+ Lead Generation Campaign with",
      "description": "This article explains \"Create an Upgraded Smart+ Lead Generation Campaign with Location as Instant Form\" and provides practical guidance for working with."
    },
    "1739084248002626": {
      "title": "Get Smart Text recommendations | TikTok API for Business",
      "description": "Use this endpoint to get Smart Text recommendations. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get Smart."
    },
    "1837969177953361": {
      "title": "Disable or enable creatives in a Smart+ Campaign",
      "description": "Use this endpoint to disable or enable one or more creatives in a Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740295890332674": {
      "title": "Get the invoices of a BC | TikTok API for Business",
      "description": "Use this endpoint to get invoices of a Business Center account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740218475032577": {
      "title": "Get posts under an identity | TikTok API for Business",
      "description": "Use this endpoint to get all posts under an identity. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get posts."
    },
    "1825108001123522": {
      "title": "Get mention content for top 1000 brand hashtag posts",
      "description": "This article explains \"Get mention content for top 1000 brand hashtag posts\" and provides practical guidance for working with TikTok API for Business."
    },
    "1834913529338882": {
      "title": "Get Authorized TTO Creator Insights Best Practices",
      "description": "Use this endpoint to get information and insights about a TikTok creator who has joined TikTok One (TTO)."
    },
    "1740571478441986": {
      "title": "Get products in a product set | TikTok API for Business",
      "description": "Use this endpoint to get products in a product set. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get products."
    },
    "1741472523309058": {
      "title": "Smart Fix Documentation | TikTok API for Business",
      "description": "This article explains \"Smart Fix\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739091153164290": {
      "title": "Pangle Best Practices | TikTok API for Business",
      "description": "Pangle is the audience network of TikTok For Business. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Pangle\"."
    },
    "1738864915188737": {
      "title": "Basic reports Overview | TikTok API for Business",
      "description": "This article explains \"Basic reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1847302935967746": {
      "title": "Create Upgraded Smart+ Mini Series Catalog Ads Guide",
      "description": "Upgraded Smart+ Mini Series Catalog Ads are Upgraded Smart+ Web Campaigns that use mini series catalog products to deliver ads."
    },
    "1847302908327938": {
      "title": "Create Upgraded Smart+ Travel Ads Best Practices",
      "description": "Upgraded Smart+ Travel Ads are Upgraded Smart+ Web Campaigns that use catalog products from travel (hotel, flight, or destination) catalogs to deliver ads."
    },
    "1740858799524865": {
      "title": "Update a pixel Overview | TikTok API for Business",
      "description": "Use this endpoint to update the Pixel name. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update a pixel\"."
    },
    "1749023065231362": {
      "title": "Creative insights Guide | TikTok API for Business",
      "description": "Creative insights help you create the best performing TikTok ad. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740218495869954": {
      "title": "Get music authorization info of a video Overview",
      "description": "Use this endpoint to get music authorization information for videos under an identity. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1739381743067137": {
      "title": "Value-Based Optimization | TikTok API for Business",
      "description": "Value-Based optimization (VBO) is a method of delivering ads to people who have a potential for becoming a high value customer."
    },
    "1835087602015234": {
      "title": "User management Guide | TikTok API for Business",
      "description": "**Required permissions(s)** : host admin<br> ## Invite new user to host admin - Enter a new email. In this guide, you'll learn what to do, when to use it, and."
    },
    "1772549012687873": {
      "title": "Create App Pre-Registration ads | TikTok API for Business",
      "description": "This article walks you through the steps to create App Pre-Registration ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1749092271949826": {
      "title": "Creative Reports Guide | TikTok API for Business",
      "description": "Creative asset level reporting is essential to understand how an advertiser's creative assets resonate with their target audience."
    },
    "1751631259350017": {
      "title": "(Deprecated) Supported filters | TikTok API for Business",
      "description": "You can use the following filters to narrow down the scope of reporting results. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1788434533212162": {
      "title": "Copy a campaign Guide | TikTok API for Business",
      "description": "This article introduces how to copy a campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Copy a campaign\"."
    },
    "1740661959804929": {
      "title": "TikTok Store Overview | TikTok API for Business (Guide)",
      "description": "A TikTok store is an entity that merchants can use to manage and sell products on TikTok. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1746463274713089": {
      "title": "Estimated Delivery Results | TikTok API for Business",
      "description": "Estimated Delivery Results (EDR) is a feature that helps improve your ad group performance by providing bid and budget suggestions."
    },
    "1843314879617026": {
      "title": "Get Upgraded Smart+ Ad Groups | TikTok API for Business",
      "description": "Use this endpoint to retrieve Upgraded Smart+ Ad Groups within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1754263154550786": {
      "title": "Use catalogs when creating Shopping Ads Overview",
      "description": "Shopping Ads is a catalog powered, smarter, and simplified paid advertising solution designed to drive maximum impact for clients' business."
    },
    "1746463347473410": {
      "title": "Get recommended bids | TikTok API for Business",
      "description": "This article explains \"Get recommended bids\" and provides practical guidance for working with TikTok API for Business."
    },
    "1781892384100354": {
      "title": "Authentication Overview | TikTok API for Business",
      "description": "This article explains \"Authentication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1773644763581441": {
      "title": "Get available locations by advertiser ID Overview",
      "description": "Use this endpoint to get available locations that your ads can be delivered to **based on your advertiser IDs**."
    },
    "1757986592010242": {
      "title": "Guides Best Practices | TikTok API for (Best Practices)",
      "description": "This guide walks you through Events API, TikTok App Events SDK, Mobile apps and Pixel. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1798658439859202": {
      "title": "Custom Product Pages | TikTok API for Business",
      "description": "This article explains \"Custom Product Pages\" and provides practical guidance for working with TikTok API for Business."
    },
    "1749019667506177": {
      "title": "Stickers Documentation | TikTok API for Business",
      "description": "Countdown Sticker You can now use Countdown Sticker type in your ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1805640900563969": {
      "title": "Get trending catalog product categories Overview",
      "description": "This article explains \"Get trending catalog product categories\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843697576682497": {
      "title": "Get the Comment-to-Message setting of a Business Account",
      "description": "Use this endpoint to get the status of the Comment-to-Message feature for a Business Account. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1739362202742785": {
      "title": "Get recommended CTAs | TikTok API for Business",
      "description": "Use this endpoint to get recommended call-to-actions (CTAs) that you can use to create or update your ads."
    },
    "1795929012554754": {
      "title": "Pixel Cookie consent mode | TikTok API for Business",
      "description": "This article explains \"Pixel Cookie consent mode\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825103341635586": {
      "title": "Overview Documentation | TikTok (Best Practices)",
      "description": "Understanding community conversations towards your business is essential for effective marketing. In this guide, you'll learn what to do, when to use it, and."
    },
    "1834189985160193": {
      "title": "Upgrade from Product Sales or Website Conversions to the",
      "description": "This article explains \"Upgrade from Product Sales or Website Conversions to the Sales objective\" and provides practical guidance for working with TikTok API."
    },
    "1843314908153858": {
      "title": "Update the operation statuses of Upgraded Smart+ Ad Groups",
      "description": "Use this endpoint to enable, pause, or delete Upgraded Smart+ Ad Groups. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1738865030529025": {
      "title": "Interest category Guide | TikTok API for Business",
      "description": "Interest category is used mainly in three ways on TikTok API for Business platform now. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1738855099573250": {
      "title": "Create an account Guide | TikTok API for Business",
      "description": "Before you can use TikTok API for Business, you need to sign up at the TikTok For Business Developers portal."
    },
    "1751098904942594": {
      "title": "Apply for Spark Ads authorization Best Practices",
      "description": "This article explains \"Apply for Spark Ads authorization\" and provides practical guidance for working with TikTok API for Business."
    },
    "1827645480080385": {
      "title": "Create Smart+ Lead Generation Campaigns Overview",
      "description": "This article walks you through the steps to create Smart+ Lead Generation Campaigns. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1797016593782785": {
      "title": "Get details of potential audiences Best Practices",
      "description": "Use this endpoint to get the details of your potential audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1847302969710913": {
      "title": "Create an Upgraded Smart+ Lead Generation (Overview)",
      "description": "This article explains \"Create an Upgraded Smart+ Lead Generation Campaign with optimization location as TikTok direct messages\" and provides practical guidance."
    },
    "1740132803511297": {
      "title": "BC Invoices Overview | TikTok API for Business",
      "description": "This article explains \"BC Invoices\" and provides practical guidance for working with TikTok API for Business."
    },
    "1822009220448257": {
      "title": "Create Product GMV Max Campaigns | TikTok API for Business",
      "description": "This article walks you through the steps to create Product GMV Max Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739432717798401": {
      "title": "Get assets Documentation | TikTok API for Business",
      "description": "Use this endpoint to get assets that you or a particular user has access to. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1738855331457026": {
      "title": "Sandbox accounts Guide | TikTok API for Business",
      "description": "With TikTok API for Business sandbox accounts, you can easily test your integration without impacting your real TikTok For Business account."
    },
    "1740133137507393": {
      "title": "Identity Documentation | TikTok API for Business",
      "description": "The Identity feature lets you choose how you present your business in your ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739067107903489": {
      "title": "Edit an image Overview | TikTok API for Business",
      "description": "Use this endpoint to edit an image. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Edit an image\"."
    },
    "1836061597865986": {
      "title": "Check the capability of a Business Account for a",
      "description": "Use this endpoint to check whether a TikTok Business Account can send images and/or receive images in a specific conversation."
    },
    "1761236883355649": {
      "title": "Search for location targeting tags Best Practices",
      "description": "Use this endpoint to search for location targeting tags by keyword. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1815124785075201": {
      "title": "Manage TikTok post ad authorization Best Practices",
      "description": "This article walks you through how to manage the ad authorization settings for TikTok posts. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740218453385217": {
      "title": "Get info about an identity | TikTok API for Business",
      "description": "Use this endpoint to retrieve details about an identity. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get info."
    },
    "1830337139853313": {
      "title": "TTO Creator Marketplace Content Linking Overview",
      "description": "Content Linking is a feature of the TikTok One (TTO) API designed to enhance performance tracking for organic creator videos on TikTok."
    },
    "1740859218541569": {
      "title": "Report App Events in bulk | TikTok API for Business",
      "description": "Use this endpoint to report app events in bulk to reduce traffic to the Marketing API. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1848591212970082": {
      "title": "Get Search Ads Campaign Health diagnoses Overview",
      "description": "Use this endpoint to retrieve health diagnoses for your ad groups or ads within a Search Ads Campaign."
    },
    "1843317390059522": {
      "title": "Create an Upgraded Smart+ Ad | TikTok API for Business",
      "description": "Use this endpoint to create an Upgraded Smart+ Ad. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1758615737388033": {
      "title": "Get the application log of audiences Documentation",
      "description": "Use this endpoint to get the latest application log of custom audiences. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739315728330753": {
      "title": "Campaign Documentation | TikTok API for Business (Guide)",
      "description": "Campaigns are the highest level of advertising. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Campaign\"."
    },
    "1828926473158657": {
      "title": "About the combined TikTok App Events SDK and Pangle SDK",
      "description": "Overview 1. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"About the combined TikTok App Events SDK and Pangle."
    },
    "1810521297052673": {
      "title": "Delete a TikTok account Webhook configuration Guide",
      "description": "Use this endpoint to delete an existing configuration for Webhook events related to your TikTok account activities at the developer app level."
    },
    "1799004052020225": {
      "title": "Events API and Pixel setup | TikTok API for Business",
      "description": "This article explains \"Events API and Pixel setup\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739029311687681": {
      "title": "Check the status of an export task (blocked words)",
      "description": "Use this endpoint to check the status of a blocked word export task. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1746998648212482": {
      "title": "Audience types Overview | TikTok API for Business",
      "description": "TikTok API for Business supports creating Custom Audiences and Lookalike Audiences. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1747747180830722": {
      "title": "Get details of contextual tags | TikTok API for Business",
      "description": "Use this endpoint to get the detailed information of contextual tags. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739583651652673": {
      "title": "Mobile apps Overview | TikTok API for Business",
      "description": "This article explains \"Mobile apps\" and provides practical guidance for working with TikTok API for Business."
    },
    "1742666501911553": {
      "title": "Update the time of a split test | TikTok API for Business",
      "description": "Use this endpoint to update the start time and end time of a split test. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740662135093314": {
      "title": "Creative basic reports | TikTok API for Business (Guide)",
      "description": "Run a creative basic report Use this endpoint to run a basic report on creative assets. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1740665332455426": {
      "title": "(Deprecated) Delete a video package Best Practices",
      "description": "Use this endpoint to delete a video package. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"(Deprecated) Delete a."
    },
    "1839151931301954": {
      "title": "Get Payment Portfolios | TikTok API for Business",
      "description": "Use this endpoint to retrieve the list of Payment Portfolios that belong to the same client as the Business Center."
    },
    "1754705318594562": {
      "title": "Assets Best Practices | TikTok API for Business",
      "description": "You can use Business Center API to manage assets or Asset Groups in a Business Center. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1822000988713089": {
      "title": "Create a GMV Max Campaign | TikTok API for Business",
      "description": "Use this endpoint to create a GMV Max Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a GMV Max."
    },
    "1739965703387137": {
      "title": "Obtain a long-term access token | TikTok API for Business",
      "description": "Use one of the two endpoints to generate a long-term access token: `/oauth2/access_token/` and `/oauth/token/`."
    },
    "1741468875279361": {
      "title": "Create a Smart Fix task | TikTok API for Business",
      "description": "Use this endpoint to create a task to automatically detect and fix video issues. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1771101049613313": {
      "title": "Verify Offline Events API setup | TikTok API for Business",
      "description": "Verify that events are received correctly Navigate to **Tools** > **Events** > **Data sources** button."
    },
    "1855027294743554": {
      "title": "Get ad accounts linked to a TikTok account in Business",
      "description": "Use this endpoint to retrieve the list of ad accounts linked to a TikTok account in a Business Center."
    },
    "1799186631031809": {
      "title": "AIGC self-disclosure toggle | TikTok API for Business",
      "description": "This article explains \"AIGC self-disclosure toggle\" and provides practical guidance for working with TikTok API for Business."
    },
    "1822001184635905": {
      "title": "Get the TikTok Shop exclusive authorization status of an ad",
      "description": "Use this endpoint to check whether an ad account is exclusively authorized to create GMV Max Campaigns for a specific TikTok Shop."
    },
    "1781891256601602": {
      "title": "Authorization Overview | TikTok API for Business",
      "description": "This article explains \"Authorization\" and provides practical guidance for working with TikTok API for Business."
    },
    "1759238007931906": {
      "title": "Advertising Policies | TikTok API for Business",
      "description": "This article explains \"Advertising Policies\" and provides practical guidance for working with TikTok API for Business."
    },
    "1751443956638721": {
      "title": "Supported dimensions | TikTok API for Business",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1738964064361474": {
      "title": "Manage catalogs in a Business Center Documentation",
      "description": "This article discusses how to manage catalogs in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1751625293044737": {
      "title": "Supported metrics Guide | TikTok API for (Overview)",
      "description": "You can use the following metrics in DSA reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1832184619749377": {
      "title": "Get the automatic messages for a Business Account",
      "description": "Use this endpoint to retrieve the automatic messages for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739578479392770": {
      "title": "Product image requirements | TikTok API for Business",
      "description": "When you upload or update a product, the product images must be equal to or larger than 500x500 px in size."
    },
    "1815051784582210": {
      "title": "Extend the authorization validity period of a TikTok post",
      "description": "Use this endpoint to extend the validity period of an existing authorization code of a TikTok post. In this guide, you'll learn what to do, when to use it, and."
    },
    "1758528841973762": {
      "title": "Reporting Documentation | TikTok API for Business",
      "description": "This article walks you through the steps to run a synchronous or asynchronous report. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1762228456608770": {
      "title": "Like/unlike an existing comment on an owned video",
      "description": "Use this endpoint to like or unlike an existing comment on an organic video posted by an owned TikTok Account."
    },
    "1739403070695426": {
      "title": "Preview an ad or a creative | TikTok API for Business",
      "description": "Use this endpoint to preview an ad or a creative. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Preview an ad or."
    },
    "1740859313270786": {
      "title": "Get the app list Guide | TikTok API for Business",
      "description": "Use this endpoint to obtain the list of apps under your account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1839151483689986": {
      "title": "BC Payment Portfolios | TikTok API for Business",
      "description": "This article explains \"BC Payment Portfolios\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739584951798785": {
      "title": "Overview Documentation | TikTok API (Tutorial)",
      "description": "Roles and concepts - **Advertiser**: The advertiser is the entity that promotes an app and owns an Ad Account on TikTok For Business."
    },
    "1843314914438466": {
      "title": "Update the budgets of Upgraded Smart+ Ad Groups",
      "description": "Use this endpoint to update the budgets of Upgraded Smart+ Ad Groups. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1771100984456193": {
      "title": "Verify Events API setup | TikTok API for Business",
      "description": "This article introduces how to verify web data connection setup. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1772544628718594": {
      "title": "Currency-specific precision | TikTok API for Business",
      "description": "The supported precision is related to the currency of your advertiser account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1851286489283585": {
      "title": "Get the campaign labels of an ad account Overview",
      "description": "Use this endpoint to retrieve the list of campaign labels within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740302848100353": {
      "title": "Run a synchronous report | TikTok API for Business (Guide)",
      "description": "Use this endpoint to create a synchronous report task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Run a."
    },
    "1803073629472770": {
      "title": "GMV max ads reports | TikTok API for Business",
      "description": "This article explains \"GMV max ads reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1749001662156801": {
      "title": "Update an Asset Group | TikTok API for Business",
      "description": "Use this endpoint to update assets, members or the name of an Asset Group. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1819581869993025": {
      "title": "Work with Paylopad Helper for App Best Practices",
      "description": "This article walks you through the steps of using the Payload Helper for App to construct your payload for reporting App Events using Events API 2.0."
    },
    "1739054080455681": {
      "title": "Get the fields of an Instant Form Best Practices",
      "description": "Use this endpoint to get the fields of an Instant Form (or lead form). In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1740302141934593": {
      "title": "API reference Overview | TikTok (Guide)",
      "description": "This group consists of the following endpoints: ## Authentication * [Get, renew or revoke a Creator access token](https://business-api.tikto."
    },
    "1747012172250114": {
      "title": "Create a Custom Audience | TikTok API for Business",
      "description": "This topic introduces how to create Custom Audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a."
    },
    "1825117875361793": {
      "title": "Obtain authorization and authentication from a TTO Creator",
      "description": "This guide outlines the process of obtaining authorization and authentication from a TikTok One (TTO) Creator Marketplace account as a developer."
    },
    "1839151986039809": {
      "title": "Create a Payment Portfolio | TikTok API for Business",
      "description": "Use this endpoint to create a Payment Portfolio. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a Payment."
    },
    "1739662828320769": {
      "title": "Get the assets of a partner | TikTok API for Business",
      "description": "Use this endpoint to get assets that you have shared with a partner, or assets that are shared by a partner."
    },
    "1816378813274113": {
      "title": "Get top TTO creator rankings | TikTok API for Business",
      "description": "Use this endpoint to obtain a list of up to 100 US creators who rank highest for a ranking label on TikTok One (TTO) Creator Leaderboard."
    },
    "1739438211077121": {
      "title": "Assign an asset Guide | TikTok API for Business",
      "description": "Use this endpoint to assign an asset in the Business Center to a TikTok For Business user that is already in the Business Center."
    },
    "1762228496095234": {
      "title": "Publish a public video post to an owned account",
      "description": "Use this endpoint to publish a public video post to an owned TikTok Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1749023062758401": {
      "title": "Creative basic reports | TikTok API for Business",
      "description": "This article explains \"Creative basic reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740489855138818": {
      "title": "Query contracts Guide | TikTok API for Business",
      "description": "Use this endpoint to query contracts. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Query contracts\"."
    },
    "1739662800930817": {
      "title": "Cancel the sharing of assets | TikTok API for Business",
      "description": "Use this endpoint to cancel the sharing of assets with a partner. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1747553433902082": {
      "title": "App promotion Overview | TikTok API for Business",
      "description": "With the App promotion objective, you can find users to install your mobile app and re-engage your app's users."
    },
    "1739953274550273": {
      "title": "Include disclaimers in ads | TikTok API for Business",
      "description": "To promote certain products (like pharmaceutical products), advertisers are required by law to display disclaimers in ads."
    },
    "1740050161973250": {
      "title": "Get info about videos | TikTok API for Business",
      "description": "Use this endpoint to get the information about a list of videos that can be used in ads from the Asset Library."
    },
    "1740310064588801": {
      "title": "Delete a catalog Guide | TikTok API for Business",
      "description": "Use this endpoint to delete an existing catalog. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete a catalog\"."
    },
    "1751631253780482": {
      "title": "(Deprecated) Supported dimensions Best Practices",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"(Deprecated)."
    },
    "1740492491200513": {
      "title": "Bind an event source to a catalog Best Practices",
      "description": "Use this endpoint to bind an app event or a website event to a catalog in a Business Center. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1739566530595841": {
      "title": "API reference Overview | TikTok API for (Best Practices)",
      "description": "This group consists of the following endpoints. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"API reference\"."
    },
    "1832184349193282": {
      "title": "Business Messaging Guide | TikTok API for Business",
      "description": "Messaging is an integral part of how businesses manage their presence as well as doing business with users on social media platforms."
    },
    "1740858904557570": {
      "title": "Get Pixel Event statistics | TikTok API for Business",
      "description": "Use this endpoint to view statistics of event data over a period of time. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1763404664004609": {
      "title": "Get Creator insights | TikTok API for Business",
      "description": "The following endpoints are available for Creator insights. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1810521730276354": {
      "title": "Subscribe to TikTok account Webhook events via Webhooks API",
      "description": "This article walks you through the steps to receive notifications for TikTok post publishing status and comment updates on TikTok accounts via Webhooks."
    },
    "1832184100272338": {
      "title": "Guides Best Practices | TikTok API (Best Practices)",
      "description": "These guides walk you through the onboarding process and some useful resources of Business Messaging API."
    },
    "1739381193120770": {
      "title": "Ads structure Overview | TikTok API for Business",
      "description": "The ads structure is made up of three levels. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Ads structure\"."
    },
    "1740307384545345": {
      "title": "(Deprecated) Dynamic Scene | TikTok API for Business",
      "description": "This article explains \"(Deprecated) Dynamic Scene\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739029296119809": {
      "title": "Create an export task (blocked words) Documentation",
      "description": "Use this endpoint to create a blocked word export task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1753994966965249": {
      "title": "Get ad accounts linked to a pixel Best Practices",
      "description": "Use this endpoint to get a list of ad accounts that have been linked to the pixel that you specify in the request."
    },
    "1832184630106386": {
      "title": "Delete the automatic message for a Business Account",
      "description": "Use this endpoint to delete an automatic message for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1828929329184770": {
      "title": "Create and manage a TTO Creator Marketplace campaign",
      "description": "This article outlines how to create and manage TikTok One (TTO) Creator Marketplace campaigns via API."
    },
    "1835087643351106": {
      "title": "Uninstall the Events API Gateway | TikTok API for Business",
      "description": "1. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Uninstall the Events API Gateway\"."
    },
    "1739584855420929": {
      "title": "Get started Overview | TikTok API for Business (Guide)",
      "description": "This article explains \"Get started\" and provides practical guidance for working with TikTok API for Business."
    },
    "1836584318657537": {
      "title": "Join a TTO Creator Marketplace campaign as a creator",
      "description": "Use this endpoint to join a TikTok One (TTO) Creator Marketplace campaign as a TikTok creator. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1775103049049090": {
      "title": "Negative Keywords Guide | TikTok API for Business",
      "description": "Negative keywords are a feature that helps you optimize Search Ads delivery by filtering out irrelevant queries or queries that may affect your brand safety."
    },
    "1770016073586753": {
      "title": "Check Value-Based Optimization eligibility Overview",
      "description": "This article explains \"Check Value-Based Optimization eligibility\" and provides practical guidance for working with TikTok API for Business."
    },
    "1771100779668482": {
      "title": "Events API 2.0 Overview | TikTok API for Business",
      "description": "This article explains \"Events API 2.0\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740307202170881": {
      "title": "Instant Page Editor SDK | TikTok API for Business",
      "description": "This article explains \"Instant Page Editor SDK\" and provides practical guidance for working with TikTok API for Business."
    },
    "1824449956282370": {
      "title": "Send or revoke a TTO video linking request Overview",
      "description": "Use this endpoint to send a request for linking a creator's public video to a TikTok One (TTO) Creator Marketplace campaign, or revoke such a request."
    },
    "1762228474532865": {
      "title": "Hide/unhide an existing comment on an owned video",
      "description": "Use this endpoint to hide or unhide an existing comment on an organic video posted by an owned TikTok Account."
    },
    "1829079287639041": {
      "title": "Get the cost records of a BC and ad accounts Guide",
      "description": "Use this endpoint to retrieve the cost records at the ad account and Business Center levels. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1780803490136066": {
      "title": "Troubleshoot catalogs with diagnostics Documentation",
      "description": "This article explains \"Troubleshoot catalogs with diagnostics\" and provides practical guidance for working with TikTok API for Business."
    },
    "1751617879104514": {
      "title": "Supported dimensions | TikTok API for Business (Overview)",
      "description": "A dimension is an attribute to group your data by. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1749001665910786": {
      "title": "Get all Asset Groups | TikTok API for Business",
      "description": "Use this endpoint to get all Asset Groups in your Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1757262274182145": {
      "title": "Reporting performance improvements Best Practices",
      "description": "A growing number of business users are now using our Reporting API to run synchronous reports. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1760232109619202": {
      "title": "Get comments on an owned video | TikTok API for Business",
      "description": "This article explains \"Get comments on an owned video\" and provides practical guidance for working with TikTok API for Business."
    },
    "1788434394151938": {
      "title": "Create an asynchronous campaign copy task Overview",
      "description": "Use this endpoint to create an asynchronous campaign copy task. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1822001024720897": {
      "title": "Get the recommended GMV Max ROI target and budget",
      "description": "Use this endpoint to obtain the recommended ROI target and budget for a Product GMV Max or Live GMV Campaign that uses a specific TikTok Shop."
    },
    "1739562438061058": {
      "title": "API reference Overview | TikTok API for Business",
      "description": "The following endpoints are available for Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"API."
    },
    "1805266308200514": {
      "title": "Payload Converter Guide | TikTok API for Business",
      "description": "This guide takes you through the process of using the Payload Converter for the Events API. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1843317489576961": {
      "title": "Run an Upgraded Smart+ Creative Overview Report",
      "description": "Use this endpoint to retrieve an Upgraded Smart+ Creative Overview Report, an overview of the reporting data on creatives within Upgraded Smart+ Ads."
    },
    "1769325308162050": {
      "title": "Check the URL property verification result Overview",
      "description": "Use this endpoint to check the result of the ownership verification for an URL property (domain or URL prefix)."
    },
    "1855027260369921": {
      "title": "Unlink a TikTok account from an ad account in Business",
      "description": "Use this endpoint to unlink a TikTok account from an ad account in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1803073913733121": {
      "title": "Supported metrics Guide | TikTok API for (Guide)",
      "description": "You can use the following metrics in GMV max ads reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740898639412226": {
      "title": "Get Instant Page events | TikTok API for Business",
      "description": "Use this endpoint to get the supported events for Instant Pages based on your objective types and optimization goals."
    },
    "1810521279479810": {
      "title": "Create or update a TikTok account Webhook configuration",
      "description": "Use this endpoint to create or update the configurations for Webhook events related to your TikTok account activities at the developer app level."
    },
    "1759233493240834": {
      "title": "Showcase Documentation | TikTok API for Business",
      "description": "Showcase is a feature on TikTok that allows customers to shop directly from a seller’s or a creator’s account."
    },
    "1758528372513794": {
      "title": "Set up Reach & Frequency campaigns Best Practices",
      "description": "This article walks you through the steps to set up Reach & Frequency (R&F) campaigns. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739470718398465": {
      "title": "(Deprecated) Automated Creative Optimization Guide",
      "description": "Automated Creative Optimization (ACO) automatically combines and delivers high-quality creative materials."
    },
    "1789700050715650": {
      "title": "Video Insights reports | TikTok API for Business (Guide)",
      "description": "This article explains \"Video Insights reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739029277346817": {
      "title": "Delete blocked words | TikTok API for Business",
      "description": "Use this endpoint to delete one or more blocked words from the blocked word list. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1739939140408322": {
      "title": "Get the transaction records of a BC Best Practices",
      "description": "Use this endpoint to get the transaction records of your Business Centers. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1766042058952706": {
      "title": "FAQs Best Practices | TikTok (Overview)",
      "description": "This article collects some common questions about authorization before you use the Accounts API. In this guide, you'll learn what to do, when to use it, and."
    },
    "1747012174934018": {
      "title": "Create a Lookalike Audience | TikTok API for Business",
      "description": "This article introduces how to create Lookalike Audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1749001426121730": {
      "title": "BC Asset Groups Guide | TikTok API for Business",
      "description": "This article explains \"BC Asset Groups\" and provides practical guidance for working with TikTok API for Business."
    },
    "1780154541898754": {
      "title": "Create a Saved Audience | TikTok API for Business (Guide)",
      "description": "Use this endpoint to create a Saved Audience. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a Saved."
    },
    "1835052243486786": {
      "title": "Events API for CRM Guide | TikTok API for Business",
      "description": "This article explains \"Events API for CRM\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740858697598978": {
      "title": "Get pixels Documentation | TikTok API for Business",
      "description": "Use this endpoint to obtain a list of Pixel information. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1754000480307265": {
      "title": "Get asynchronous download tasks | TikTok API for Business",
      "description": "Use this endpoint to check whether the `BILLING_REPORT` task has completed. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1838630375757825": {
      "title": "Get recommended search keywords | TikTok API for (Guide)",
      "description": "Use this endpoint to obtain a list of recommended search keywords with predicted monthly searches for Search Ads Campaigns."
    },
    "1749018853745665": {
      "title": "Call-to-action texts | TikTok API for Business",
      "description": "Call-to-action (CTA) button refers to the text in the ad that guides the user to take some kind of action after seeing the ad."
    },
    "1739432611975170": {
      "title": "BC Partners Overview | TikTok API for Business",
      "description": "This article explains \"BC Partners\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739029218470913": {
      "title": "Create blocked words | TikTok API for Business",
      "description": "Use this endpoint to add words to the blocked word list. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1855007137120578": {
      "title": "Create Upgraded Smart+ Catalog Ads with Website and App",
      "description": "This article explains \"Create Upgraded Smart+ Catalog Ads with Website and App Optimization\" and provides practical guidance for working with TikTok API for."
    },
    "1739091950439426": {
      "title": "Create a portfolio Guide | TikTok API for Business",
      "description": "Use this endpoint to create a portfolio of creative assets. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1822106498804738": {
      "title": "Get welcome messages within an ad account Overview",
      "description": "Use this endpoint to retrieve the welcome messages within the welcome message library of your ad account."
    },
    "1740858862104578": {
      "title": "Delete a Pixel Event | TikTok API for Business",
      "description": "Use this endpoint to delete Pixel events. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete a Pixel Event\"."
    },
    "1839876593708034": {
      "title": "Create ads with Website and App Optimization Guide",
      "description": "This article walks you through the steps to create ads with Website and App Optimization. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1754705407307777": {
      "title": "Assets Best Practices | TikTok API for Business (Guide)",
      "description": "This article explains \"Assets\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739433007779841": {
      "title": "Get assets as admin | TikTok API for Business",
      "description": "Use this endpoint to get additional information about assets in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1749019605861377": {
      "title": "Interactive Add-ons | TikTok API for Business",
      "description": "Interactive Add-ons capture the undivided attention of your audience in a full-screen, sound-on environment to boost brand engagement and encourage interaction."
    },
    "1783164662979586": {
      "title": "Smart Targeting Guide | TikTok API for Business",
      "description": "Smart Targeting is an intelligent feature that helps you find the users most likely to complete your objective."
    },
    "1762228442072066": {
      "title": "Create a new comment on an owned video Documentation",
      "description": "Use this endpoint to create a new comment on an organic video posted by an owned TikTok Account. In this guide, you'll learn what to do, when to use it, and."
    },
    "1764306884771842": {
      "title": "Filterable destination page type for an advertising",
      "description": "This article explains \"Filterable destination page type for an advertising objective\" and provides practical guidance for working with TikTok API for Business."
    },
    "1822001168512129": {
      "title": "Get posts for a Product GMV Max Campaign Overview",
      "description": "Use this endpoint to retrieve the list of TikTok posts that are available for a Product GMV Max campaign using a specific TikTok Shop."
    },
    "1769325247778818": {
      "title": "URL properties Overview | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Add an URL property to an ad account](https://ads.tiktok.com/marketing_api/docs?id=1769325."
    },
    "1746463333984258": {
      "title": "Get recommended budgets | TikTok API for Business",
      "description": "Budget EDR (Estimated Delivery Results) enables you to adopt the suitable budget from estimated results to scale up your ad group and drive more conversions."
    },
    "1771100799076354": {
      "title": "Events API for Web Guide | TikTok API for Business",
      "description": "This article explains \"Events API for Web\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825128700959746": {
      "title": "Get Spark Ads video recommendations for a TTO account",
      "description": "Use this endpoint to obtain the Spark Ads recommendation results for up to 100 video posts associated with your TikTok One (TTO) Creator Marketplace account."
    },
    "1739939455765505": {
      "title": "Invite members to a BC | TikTok API for Business",
      "description": "Use this endpoint to invite members to a Business Center and assign roles and assets to members. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739029325203457": {
      "title": "Download exported data | TikTok API for Business",
      "description": "Use this endpoint to download the exported blocked words when an export task completes. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1769113205729282": {
      "title": "Access token inspector | TikTok API for Business",
      "description": "This group consists of the following endpoint: - [Get the authorized TikTok account permission scopes via access token](https://ads.tiktok.c."
    },
    "1758526010304514": {
      "title": "Audience integration | TikTok API for Business",
      "description": "This article walks you through the steps of audience integration. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1805640886872066": {
      "title": "Get trending catalog products | TikTok API for Business",
      "description": "Use this endpoint to retrieve up to top 50 trending products based on user engagement on TikTok within an E-commerce catalog."
    },
    "1810521243195393": {
      "title": "Webhooks Documentation | TikTok API for Business (Guide)",
      "description": "This group consists of the following endpoints: - [Create or update a TikTok account Webhook configuration](https://business-api.tiktok.com/."
    },
    "1839594049581249": {
      "title": "Unlock conversations | TikTok API for Business",
      "description": "This guide offers a comprehensive overview of the steps required to generate and effectively use TikTok.me Short Links to enhance customer engagement."
    },
    "1740573143966722": {
      "title": "Delete product sets | TikTok API for Business",
      "description": "Use this endpoint to delete product sets in a catalog under a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1822009242546258": {
      "title": "Create LIVE GMV Max Campaigns | TikTok API for Business",
      "description": "This article walks you through the steps to create LIVE GMV Max Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1796638342793218": {
      "title": "Search for or list targeting categories and hashtags for",
      "description": "Use this endpoint to search for targeting categories and hashtags related to interests and behaviors based on seed keywords."
    },
    "1805640759207937": {
      "title": "Catalog Insights Guide | TikTok API for Business",
      "description": "This article explains \"Catalog Insights\" and provides practical guidance for working with TikTok API for Business."
    },
    "1754705321657346": {
      "title": "Finance Best Practices | TikTok API for Business",
      "description": "You (**users with Finance Manager or Finance Analyst permission**) can use Business Center API to manage payments and invoices in Business Center."
    },
    "1793482248880130": {
      "title": "Get products within a TikTok Shop Best Practices",
      "description": "Use this endpoint to retrieve the products within a first-party store (TikTok Shop). In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740673047618561": {
      "title": "Mapping between campaign features in and API configurations",
      "description": "This article provides the mapping between TikTok Ads Manager (TTAM) features at the campaign, ad group, and ad levels and the corresponding API configurations."
    },
    "1739585696931842": {
      "title": "Supported Pixel events | TikTok API for Business",
      "description": "Pixel events Please find all the 18 Web events in the following table. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1760334514340866": {
      "title": "Guides Best Practices | TikTok API for (Tutorial)",
      "description": "This guide walks you through the onboarding process and some useful resources of Accounts API. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740665183073281": {
      "title": "Get feeds Documentation | TikTok API for Business",
      "description": "Use this endpoint to get the information about a particular feed or all feeds for a catalog. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1767322784934914": {
      "title": "Smart Creative Overview | TikTok API for Business",
      "description": "Smart Creative is a comprehensive AI-powered tool that houses creative diagnose and asset reporting, auto-generation, and delivery optimization under one roof."
    },
    "1847839827327106": {
      "title": "Available targeting settings for different targeting",
      "description": "This article explains \"Available targeting settings for different targeting optimization modes in Upgraded Smart+ Ad Groups\" and provides practical guidance."
    },
    "1803655103069185": {
      "title": "Delete uploaded catalog videos | TikTok API for Business",
      "description": "Use this endpoint to delete uploaded catalog videos from an E-commerce catalog. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1766324010279938": {
      "title": "Get portfolios within an ad account Best Practices",
      "description": "Use this endpoint to retrieve portfolios created within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1753986142651394": {
      "title": "Permission scope Guide | TikTok API for Business",
      "description": "TikTok API for Business permissions consist of three levels: first level, second level, and third level."
    },
    "1739657891856385": {
      "title": "Events 1.0 Documentation | TikTok API for Business",
      "description": "> <span style=\"color:DodgerBlue\">**Note**</span><br> > The following six Events API 1.0 endpoints will be sunset in H2 2024."
    },
    "1826564934723585": {
      "title": "Create a webpage anchor | TikTok API for Business",
      "description": "Use this endpoint to create a webpage anchor of the web destination link type. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1776983576127490": {
      "title": "FAQs Best Practices | TikTok (Best Practices)",
      "description": "This article summarizes FAQs about the Accounts API. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"FAQs\"."
    },
    "1739939116353538": {
      "title": "Get the transaction records of ad accounts Overview",
      "description": "Use this endpoint to get the transaction records of ad accounts in the Business Center. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1744571210012673": {
      "title": "API reference Overview | TikTok API for (Tutorial)",
      "description": "The Reach & Frequency API consists of the following endpoints: - Manage R&F campaigns * [Get campaigns](https://ads.tiktok.com/marketing_api."
    },
    "1740859300069378": {
      "title": "Update an app Overview | TikTok API for Business",
      "description": "Use this endpoint to update a mobile App. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update an app\"."
    },
    "1825127842289729": {
      "title": "API Reference Overview | TikTok API for Business",
      "description": "This article explains \"API Reference\" and provides practical guidance for working with TikTok API for Business."
    },
    "1835087595419649": {
      "title": "Tenants Best Practices | TikTok API for Business",
      "description": "Create tenant account **Required permissions(s)** : Tenant Admin - Enter the name of the new tenant you want to create."
    },
    "1763403737310209": {
      "title": "Guides Best Practices | TikTok API (Overview)",
      "description": "These guides walk you through the general workflow and functionality of the TikTok One (TTO) API. In this guide, you'll learn what to do, when to use it, and."
    },
    "1765927978092545": {
      "title": "Get the authorized TikTok account permission scopes via",
      "description": "Use this endpoint to get the permission scopes of a TikTok Business Account or a TikTok Personal Account that are authorized by the TikTok account user."
    },
    "1839151992566081": {
      "title": "Link ad accounts to a Payment Portfolio Overview",
      "description": "Use this endpoint to link an ad account to a Payment Portfolio. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740570027173889": {
      "title": "Get the product handling log | TikTok API for Business",
      "description": "Use this endpoint to check if the products are uploaded or deleted successfully, and what to do if the upload or deletion fails."
    },
    "1746463732779009": {
      "title": "(To-be-deprecated) Get recommended bids Overview",
      "description": "> <span style=\"color:DarkRed\">**Important**</span><br> > This endpoint will be deprecated in the next API version."
    },
    "1740496787164161": {
      "title": "Upload products via a file URL | TikTok API for Business",
      "description": "Use this endpoint to upload products via a file URL. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload."
    },
    "1815051698931714": {
      "title": "Ad authorization Guide | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Enable or disable the ad authorization setting for a TikTok post](https://business-api.ti."
    },
    "1739320422086657": {
      "title": "Update a campaign Guide | TikTok API for Business",
      "description": "Use this endpoint to modify a campaign after it has been created. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739562436183041": {
      "title": "FAQs Best Practices | TikTok API for Business (Tutorial)",
      "description": "This article explains \"FAQs\" and provides practical guidance for working with TikTok API for Business."
    },
    "1847302920924306": {
      "title": "Create Upgraded Smart+ Streaming Ads Documentation",
      "description": "Upgraded Smart+ Streaming Ads are Upgraded Smart+ Web Campaigns that use catalog products from entertainment catalogs to deliver ads."
    },
    "1739940506015746": {
      "title": "Get all audiences Guide | TikTok API for Business",
      "description": "Use this endpoint to get all audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get all audiences\"."
    },
    "1843324498993154": {
      "title": "Create Upgraded Smart+ Lead Generation Campaigns",
      "description": "This article walks you through the steps to create Upgraded Smart+ Lead Generation Campaigns. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1839882969587906": {
      "title": "Create Manual Non-Catalog Ads with Website and App",
      "description": "This article walks you through the steps to create Manual Non-Catalog Ads with Website and App Optimization."
    },
    "1740665210863617": {
      "title": "Delete a feed Overview | TikTok API for Business",
      "description": "Use this endpoint to delete a feed. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete a feed\"."
    },
    "1831975745134593": {
      "title": "Get the details of a TTO Creator Marketplace account",
      "description": "Use this endpoint to retrieve the details of a TikTok One (TTO) Creator Marketplace account. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1815693478150146": {
      "title": "Get authorized TTO Creator Marketplace accounts",
      "description": "Use this endpoint to obtain a list of TikTok One (TTO) Creator Marketplace accounts that authorized the developer app."
    },
    "1771100879787009": {
      "title": "Send TikTok Click ID (ttclid) | TikTok API for Business",
      "description": "This article explains \"Send TikTok Click ID (ttclid)\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825119032526849": {
      "title": "Get popular hashtags | TikTok API for Business",
      "description": "Use this endpoint to get a list of the top 200 popular hashtags on TikTok. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1748896830086145": {
      "title": "Overview Documentation | TikTok API for (Overview)",
      "description": "Creative refers to multimedia elements presented to users in ads, such as videos and pictures. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1775747492072449": {
      "title": "Supported metrics for a dimension in Business Center reports",
      "description": "See the tables below to learn about the supported metrics when you use a dimension in Business Center reports."
    },
    "1775747484045313": {
      "title": "Supported filters Guide | TikTok API for (Tutorial)",
      "description": "You can use the following filters to narrow down the scope of reporting results. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825101694214273": {
      "title": "Overview Documentation | TikTok (Guide)",
      "description": "This article explains \"Overview\" and provides practical guidance for working with TikTok API for Business."
    },
    "1833833401871362": {
      "title": "Delete an enabled brand hashtag for a Business Account",
      "description": "Use this endpoint to delete enabled hashtags for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825103422736385": {
      "title": "Get started Overview | TikTok API for Business (Tutorial)",
      "description": "Welcome to Mentions API! In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get started\"."
    },
    "1769113237682177": {
      "title": "Insights Documentation | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Get profile data of a TikTok account](https://ads.tiktok.com/marketing_api/docs?id=176222."
    },
    "1825299567855617": {
      "title": "Create an MMM data request | TikTok API for Business",
      "description": "Use this endpoint to create a Media Mix Modeling (MMM) data request. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1750444779586561": {
      "title": "Bidding limits Overview | TikTok API for Business",
      "description": "This article explains \"Bidding limits\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843309449749698": {
      "title": "Create an Upgraded Smart+ Campaign Best Practices",
      "description": "This article walks you through the steps to create an Upgraded Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1820826387779586": {
      "title": "Get the Page ID Guide | TikTok API for Business",
      "description": "Use this endpoint to get the Page ID. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get the Page ID\"."
    },
    "1825119005427714": {
      "title": "Discovery Documentation | TikTok API for Business",
      "description": "This article explains \"Discovery\" and provides practical guidance for working with TikTok API for Business."
    },
    "1834543156864002": {
      "title": "Events API Gateway Guide | TikTok API for Business",
      "description": "**What is Events API Gateway** The Events API Gateway is a simplified means of delivering server-side data to TikTok's Events API endpoint."
    },
    "1824450033584129": {
      "title": "Get TTO video linking requests as a brand Overview",
      "description": "This article explains \"Get TTO video linking requests as a brand\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740050472224769": {
      "title": "Search for videos Guide | TikTok API for Business",
      "description": "Use this endpoint to search for video creatives that can be used in ads in the Asset Library of an ad account."
    },
    "1754263112945665": {
      "title": "Create catalogs and add products | TikTok API for Business",
      "description": "This article discusses how to create a catalog and add products to the catalog via Catalog APIs. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740029173531649": {
      "title": "Dedicated Campaign Guide | TikTok API for Business",
      "description": "Dedicated Campaigns are a special type of campaign that targets devices running iOS 14.5 and later versions."
    },
    "1781891416235009": {
      "title": "Marketing API Overview | TikTok API for Business",
      "description": "This article explains \"Marketing API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843312876001282": {
      "title": "Update an Upgraded Smart+ Campaign Best Practices",
      "description": "Use this endpoint to update an Upgraded Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update an."
    },
    "1825107783639042": {
      "title": "API reference Overview | TikTok API (Tutorial)",
      "description": "Mentions API is a tool for monitoring mentions and analyzing community conversations about your business on TikTok."
    },
    "1774482920012801": {
      "title": "Create a Lead Generation ad with optimization location as",
      "description": "This article explains \"Create a Lead Generation ad with optimization location as Instant Form\" and provides practical guidance for working with TikTok API for."
    },
    "1767568085608450": {
      "title": "Creative Fatigue Detection | TikTok API for Business",
      "description": "This article explains \"Creative Fatigue Detection\" and provides practical guidance for working with TikTok API for Business."
    },
    "1758485431181314": {
      "title": "Mapping between different promotion types Overview",
      "description": "This article explains \"Mapping between different promotion types\" and provides practical guidance for working with TikTok API for Business."
    },
    "1803615367145537": {
      "title": "Cancel an asynchronous report task Best Practices",
      "description": "Use this endpoint to cancel an asynchronous report task that is either queued or currently being processed."
    },
    "1749001673406466": {
      "title": "Delete Asset Groups | TikTok API for Business",
      "description": "Use this endpoint to delete Asset Groups from your Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1763402336271362": {
      "title": "Overview Documentation | TikTok (Tutorial)",
      "description": "This article explains \"Overview\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739940507792385": {
      "title": "Get audience details | TikTok API for Business",
      "description": "Use this endpoint to obtain the details of specified audiences, such as current status and modification record."
    },
    "1835087607780546": {
      "title": "Settings Documentation | TikTok API for Business",
      "description": "Primary domain setup **Required permissions(s) :** Host admin ### **With AWS** Only for the host owner, agency/partner admin."
    },
    "1766041812130817": {
      "title": "FAQs Best Practices | TikTok API for Business (Overview)",
      "description": "This article collects some common questions and error messages about authentication. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1835246983475217": {
      "title": "Delete a max delivery or creative boost session",
      "description": "This article explains \"Delete a max delivery or creative boost session\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843312852800706": {
      "title": "Create an Upgraded Smart+ Campaign Best Practices (Guide)",
      "description": "Use this endpoint to create an Upgraded Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1769113361610753": {
      "title": "Posts Best Practices | TikTok API for Business",
      "description": "This group consists of the following endpoints: - [Publish a public video post to an owned account](https://ads.tiktok.com/marketing_api/doc."
    },
    "1839152031645121": {
      "title": "Get authorized users for a Payment Portfolio Guide",
      "description": "Use this endpoint to retrieve the list of users that have access to a Payment Portfolio. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1740859272887297": {
      "title": "Get info of an app Guide | TikTok API for Business",
      "description": "Use this endpoint to obtain the details of an App. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get info of an."
    },
    "1832184219753474": {
      "title": "US data security review | TikTok API for Business",
      "description": "The US Data Security Questionnaire is provided and managed by our US Data Security (USDS) team. In this guide, you'll learn what to do, when to use it, and."
    },
    "1839882947475458": {
      "title": "Create Manual Catalog Ads with Website and App Optimization",
      "description": "This article walks you through the steps to create Manual Catalog Ads with Website and App Optimization."
    },
    "1739583617914881": {
      "title": "Ad Measurement Overview | TikTok API for Business",
      "description": "You can use event data connection tools to measure the effectiveness of your ads. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1780802101608450": {
      "title": "Get catalog event trends and match rate Overview",
      "description": "This article explains \"Get catalog event trends and match rate\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825101624331329": {
      "title": "Organic API Overview | TikTok API for Business",
      "description": "This article explains \"Organic API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1770019181843458": {
      "title": "Enable Value-Based Optimization in Manual Campaigns",
      "description": "This article walks you through the steps to enable Value-Based Optimization (VBO) in Manual Campaigns."
    },
    "1739940585975809": {
      "title": "Add/Delete audience segment mappings Documentation",
      "description": "Use this endpoint to add mappings to audience segments, or delete existing mappings from audience segments."
    },
    "1803655082498050": {
      "title": "Get the uploaded catalog videos within a catalog",
      "description": "Use this endpoint to retrieve the list of uploaded catalog videos within an E-commerce catalog. In this guide, you'll learn what to do, when to use it, and."
    },
    "1740665346584577": {
      "title": "(Deprecated) Upload a video template Documentation",
      "description": "Use this endpoint to upload a custom video template to Busines Center and associate the template with a group of catalogs."
    },
    "1739470992872450": {
      "title": "(Deprecated) Create a video package Best Practices",
      "description": "A video package is a group of videos that you can directly use in your ads, for example, Shopping Ads."
    },
    "1768006268820546": {
      "title": "Create a Smart+ Campaign | TikTok API for Business",
      "description": "This article walks you through the steps to create a Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1835052398174274": {
      "title": "FAQs Best Practices | TikTok API (Overview)",
      "description": "Q1: Is there any rate limit that we should be aware of? In this guide, you'll learn what to do, when to use it, and what to check when implementing \"FAQs\"."
    },
    "1739470723315713": {
      "title": "Reach & Frequency Guide | TikTok API for Business",
      "description": "Reach & Frequency (R&F) is a campaign buying type that helps TikTok For Business advertisers plan and buy campaigns in advance."
    },
    "1847302895272962": {
      "title": "Create Upgraded Smart+ E-commerce Catalog Ads Guide",
      "description": "Upgraded Smart+ E-commerce Catalog Ads are Upgraded Smart+ Web Campaigns that use E-commerce catalog products to deliver ads."
    },
    "1757985960801281": {
      "title": "Overview Documentation | TikTok API (Best Practices)",
      "description": "TikTok provides powerful event data connection tools to help you measure the effectiveness of your ads."
    },
    "1843317433577601": {
      "title": "Disable or enable creatives in an Upgraded Smart+ Ad",
      "description": "Use this endpoint to disable or enable one or more creatives in an Upgraded Smart+ Ad. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1843317423164482": {
      "title": "Update the operation statuses of Upgraded Smart+ Ads",
      "description": "Use this endpoint to enable, pause, or delete Upgraded Smart+ Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740317337705473": {
      "title": "(Deprecated) Get the results of an async task Guide",
      "description": "Use this endpoint to get the results of an async task. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740492531343362": {
      "title": "Get event source binding info of a catalog Overview",
      "description": "Use this endpoint to get the binding information about app or web event sources of a catalog in a Business Center."
    },
    "1738769164954626": {
      "title": "Bind/Unbind rules Guide | TikTok API for Business",
      "description": "Use this endpoint to bind objects to an existing rule, or unbind objects from a rule that they were previously bound to."
    },
    "1739584863252481": {
      "title": "Verify Events setup | TikTok API for Business",
      "description": "This article introduces how to verify web data connection setup. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1745292235571201": {
      "title": "Ad Best Practices | TikTok API for Business",
      "description": "Ad is the content that is presented to the target audience. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Ad\"."
    },
    "1738825259075586": {
      "title": "Get in-second performance | TikTok API for Business",
      "description": "Use this endpoint to get in-second performance data about ads, or Video Insights data about a video."
    },
    "1825128562548930": {
      "title": "API reference Overview | TikTok (Overview)",
      "description": "This article explains \"API reference\" and provides practical guidance for working with TikTok API for Business."
    },
    "1771101111730178": {
      "title": "Setup guide for App | TikTok API for Business",
      "description": "> <span style=\"color:DodgerBlue\">**Note**</span><br> > Reporting App Events using Events API 2.0 is currently an allowlist-only feature."
    },
    "1825103402321025": {
      "title": "Guides Best Practices | TikTok API (Guide)",
      "description": "These guides walk you through the onboarding process and some useful resources of Mentions API. In this guide, you'll learn what to do, when to use it, and."
    },
    "1739583652957185": {
      "title": "Pixel Best Practices | TikTok API for Business",
      "description": "This article explains \"Pixel\" and provides practical guidance for working with TikTok API for Business."
    },
    "1765596790860802": {
      "title": "Delete an Offline Event set | TikTok API for Business",
      "description": "Use this endpoint to delete an Offline Event set under an advertiser account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1792849810925569": {
      "title": "Get the transaction records of a BC or ad accounts",
      "description": "Use this endpoint to retrieve the transaction records of your Business Center (BC) or ad accounts within the Business Center."
    },
    "1752349244331009": {
      "title": "Disable an ad account | TikTok API for Business",
      "description": "Use this endpoint to disable an ad account in the Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740489099367425": {
      "title": "Cancel the R&F ad order | TikTok API for Business",
      "description": "Use this endpoint to withdraw an R&F ad order to suspend its delivery. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1843317378982914": {
      "title": "Get Upgraded Smart+ Ads | TikTok API for Business",
      "description": "Use this endpoint to retrieve Upgraded Smart+ Ads within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739696704424961": {
      "title": "Update info of a BC member | TikTok API for Business",
      "description": "Use this endpoint to update a member's user name and their role in the Business Center. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1832209711206401": {
      "title": "TikTok account holder redirect URL configuration",
      "description": "This article explains \"TikTok account holder redirect URL configuration\" and provides practical guidance for working with TikTok API for Business."
    },
    "1815051741912066": {
      "title": "Enable or disable the ad authorization setting for a TikTok",
      "description": "Use this to enable or disable the \"Ad authorization\" setting for a TikTok post. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1742666557045761": {
      "title": "Get the results of a split test | TikTok API for Business",
      "description": "Use this endpoint at least 24 hours after the test ends to get test results, including p-values for each metric."
    },
    "1739566532187138": {
      "title": "Create an audience by rule | TikTok API for Business",
      "description": "This article explains \"Create an audience by rule\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740859280958466": {
      "title": "Create an app Overview | TikTok API for Business",
      "description": "Use this endpoint to create a mobile App. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an app\"."
    },
    "1829744101665810": {
      "title": "Default settings for All-in-One Spark Ads Overview",
      "description": "This article explains \"Default settings for All-in-One Spark Ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1815693573340162": {
      "title": "Report on TTO Creator Marketplace videos Overview",
      "description": "Use this endpoint to obtain the reporting data on videos within a TikTok One (TTO) Creator Marketplace campaign."
    },
    "1740857881469954": {
      "title": "Pixel Events Overview | TikTok API for Business",
      "description": "This article explains \"Pixel Events\" and provides practical guidance for working with TikTok API for Business."
    },
    "1758616888158209": {
      "title": "Refresh a lookalike audience | TikTok API for Business",
      "description": "Use this endpoint to manually refresh a Lookalike Audience. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740039806891010": {
      "title": "Update the name of an image | TikTok API for Business",
      "description": "Use this endpoint to update the name of an image. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update the name."
    },
    "1739593083610113": {
      "title": "Get ad account details | TikTok API for Business",
      "description": "Use this endpoint to obtain the details of an advertiser's ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1766862002851842": {
      "title": "Upload products to different catalog types via JSON schema",
      "description": "This article walks you through the steps to upload products to various types of catalog using a JSON schema."
    },
    "1739940511844353": {
      "title": "Create a lookalike audience | TikTok API for Business",
      "description": "Use this endpoint to create a lookalike audience. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a."
    },
    "1782141580104705": {
      "title": "Mapping between Catalog Management features in Catalog",
      "description": "This article explains \"Mapping between Catalog Management features in Catalog Manager and API configurations\" and provides practical guidance for working with."
    },
    "1739473063234626": {
      "title": "Create Smart Creative ads | TikTok API for Business",
      "description": "Use this endpoint to create Smart Creative ads by uploading necessary ad creatives to the library. In this guide, you'll learn what to do, when to use it, and."
    },
    "1738855280338946": {
      "title": "App permissions Guide | TikTok API for Business",
      "description": "This article explains \"App permissions\" and provides practical guidance for working with TikTok API for Business."
    },
    "1751631257050114": {
      "title": "(Deprecated) Supported metrics | TikTok API for Business",
      "description": "You can use the following metrics in reservation ad reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1855450880142402": {
      "title": "Automatic Enhancements | TikTok API for Business",
      "description": "Automatic Enhancements is an advertising optimization product that provides creative optimization services."
    },
    "1739940583739393": {
      "title": "Create/Delete an audience segment Best Practices",
      "description": "Use this endpoint to create or delete an audience segment. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1763590894544897": {
      "title": "Get additional interest categories by ID Overview",
      "description": "Use this endpoint to get additional interest categories by ID. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1833832557996034": {
      "title": "Get enabled hashtags for a Business Account Guide",
      "description": "Use this endpoint to retrieve the hashtags that have been enabled for a Business Account. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1771101276978178": {
      "title": "Events 2.0 Documentation | TikTok API for Business",
      "description": "This article explains \"Events 2.0\" and provides practical guidance for working with TikTok API for Business."
    },
    "1750349624999937": {
      "title": "Update the schedule status of a feed Documentation",
      "description": "Use this endpoint to update the schedule status of a feed. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update."
    },
    "1752267762718722": {
      "title": "Get available stores under an ad account Overview",
      "description": "Use this endpoint to get the list of available first-party stores (TikTok Shops) under an ad account."
    },
    "1816387951979521": {
      "title": "Get the post privacy settings of a TikTok account",
      "description": "Use this endpoint to obtain the post privacy settings of a TikTok account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739352294717441": {
      "title": "(Deprecated) Create a Smart Video task Documentation",
      "description": "Use this endpoint to create a Smart Video task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"(Deprecated)."
    },
    "1771747626094593": {
      "title": "Automatic Search Placement | TikTok API for Business",
      "description": "Automatic Search Placement allows you to reach users who are searching for specific terms related to your product or service."
    },
    "1843325008693250": {
      "title": "Create Upgraded Smart+ Automotive Ads for Inventory",
      "description": "Upgraded Smart+ Automotive Ads for Inventory are Upgraded Smart+ Automotive Ads created using an Auto-Inventory catalog."
    },
    "1832184437720193": {
      "title": "Upload an image Guide | TikTok API for Business",
      "description": "Use this endpoint to upload an image. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload an image\"."
    },
    "1738864817670145": {
      "title": "Best practices to reduce timeouts in synchronous reports",
      "description": "Due to throughput limits, a synchronous request for getting a large amount of data may time out. In this guide, you'll learn what to do, when to use it, and."
    },
    "1776461365424129": {
      "title": "Metrics in Smart+ Campaign reports Best Practices",
      "description": "Below are the supported metrics for Smart+ Campaign reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1832184159540418": {
      "title": "Authorization Overview | TikTok API for (Tutorial)",
      "description": "Before you use the Business Messaging API, you (the developer) need to obtain authorization from the business to manage their TikTok Business Accounts."
    },
    "1757239620352002": {
      "title": "Supported secondary statuses for a primary status",
      "description": "See the following tables to learn about the supported secondary statuses for a certain primary status at the campaign, ad group, and ad levels."
    },
    "1739940567842818": {
      "title": "Upload an audience file | TikTok API for Business",
      "description": "Use this endpoint to upload a data file. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload an audience file\"."
    },
    "1825127824570434": {
      "title": "Rate limits for Discovery API | TikTok API for Business",
      "description": "The rate limit per Discovery API endpoint is 10 queries per second (QPS) per developer app. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1843317445798914": {
      "title": "Preview Upgraded Smart+ Ads | TikTok API for Business",
      "description": "Use this endpoint to preview an Upgraded Smart+ Ad that you want to create or an existing Upgraded Smart+ Ad."
    },
    "1771117054564354": {
      "title": "Catalog Diagnostics | TikTok API for Business",
      "description": "This article explains \"Catalog Diagnostics\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739965949088770": {
      "title": "Revoke a long-term access token | TikTok API for Business",
      "description": "Use this endpoint to revoke a long-term access token. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Revoke a."
    },
    "1826537506816001": {
      "title": "API Playground Overview | TikTok API for Business",
      "description": "The API Playground provides a streamlined environment for testing API endpoints and validating payloads."
    },
    "1745292519923713": {
      "title": "Contextual targeting | TikTok API for Business",
      "description": "This article explains \"Contextual targeting\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843310530260097": {
      "title": "Ads Best Practices | TikTok API for Business (Guide)",
      "description": "An ad is the smallest advertising unit and is the content presented to the target audience. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1740572974725122": {
      "title": "Update a product set | TikTok API for Business",
      "description": "Use this endpoint to update the filter conditions or name of a product set. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1843312818332930": {
      "title": "Get Upgraded Smart+ Campaigns | TikTok API for Business",
      "description": "Use this endpoint to retrieve Upgraded Smart+ Campaigns within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1832184584869890": {
      "title": "Create an automatic message for a Business Account",
      "description": "Use this endpoint to create an automatic message for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1759977800177665": {
      "title": "Webhooks Documentation | TikTok API for Business",
      "description": "This article explains \"Webhooks\" and provides practical guidance for working with TikTok API for Business."
    },
    "1789769972291585": {
      "title": "Video Insights reports | TikTok API for Business",
      "description": "This article explains \"Video Insights reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1742668394531842": {
      "title": "Super Split Test Guide | TikTok API for Business",
      "description": "This article explains \"Super Split Test\" and provides practical guidance for working with TikTok API for Business."
    },
    "1759232259360770": {
      "title": "Create Video Shopping Ads with products from Showcase",
      "description": "Showcase is a feature on TikTok that allows customers to shop directly from a seller’s or a creator’s account."
    },
    "1739585706138625": {
      "title": "Debug mode Documentation | TikTok API for Business",
      "description": "If you require more details as you debug your pixel setting, debug mode is here to help you. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1739578433846274": {
      "title": "Catalog Management Guide | TikTok API for Business",
      "description": "If you have a large volume of rapidly changing products, it is recommended to use the Catalog API to manage them."
    },
    "1739659584022529": {
      "title": "Get binding info of an asset | TikTok API for Business",
      "description": "Use this endpoint to check how many ads an asset has been binded to, and how many more ads this asset can be binded to."
    },
    "1829744071179330": {
      "title": "Create a campaign, an ad group, and a Spark Ad in one step",
      "description": "Use this endpoint to simultaneously set up a campaign, an ad group on the TikTok placement, and a single video Spark Ad within the ad group."
    },
    "1826463372290177": {
      "title": "Get GMV Max Campaigns | TikTok API for Business",
      "description": "Use this endpoint to retrieve the GMV Max Campaigns within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1832184321030145": {
      "title": "API Reference Overview | TikTok API for Business (Guide)",
      "description": "Messaging is an integral part of how businesses manage their presence as well as doing business with users on social media platforms."
    },
    "1740029931324417": {
      "title": "Migrate leads to a BC | TikTok API for Business",
      "description": "Use this endpoint to migrate leads from an ad account to a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1805642743426050": {
      "title": "Obtain Catalog Product Insights | TikTok API for Business",
      "description": "This article explains \"Obtain Catalog Product Insights\" and provides practical guidance for working with TikTok API for Business."
    },
    "1745292441739265": {
      "title": "Placements Documentation | TikTok API for Business",
      "description": "Placements allow you to choose where your ad will be shown. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738944324279297": {
      "title": "Get Billing Groups Guide | TikTok API for Business",
      "description": "Use this endpoint to get all Billing Groups in a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1751443975608321": {
      "title": "Supported filters Guide | TikTok API for Business",
      "description": "You can use the following filters to narrow down the scope of reporting results. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1835052369704961": {
      "title": "Verify Events API setup | TikTok API for Business (Help)",
      "description": "Verify that events are received correctly Navigate to **Tools** > **Events** > **Data sources**. In this guide, you'll learn what to do, when to use it, and."
    },
    "1843314894279682": {
      "title": "Update an Upgraded Smart+ Ad Group Best Practices",
      "description": "Use this endpoint to update an Upgraded Smart+ Ad Group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update an."
    },
    "1771101231937537": {
      "title": "Changelog Documentation | TikTok API for Business",
      "description": "The latest Events API version is: **v2.0** ## Available Events API Versions The table below lists the specific deprecation dates for each version of Events API."
    },
    "1740673108747265": {
      "title": "Product set operators and fields | TikTok API for Business",
      "description": "This article explains \"Product set operators and fields\" and provides practical guidance for working with TikTok API for Business."
    },
    "1797011827608577": {
      "title": "Create Advanced Dedicated Campaigns Best Practices",
      "description": "This article walks you through the steps to create Advanced Dedicated Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1775104916876290": {
      "title": "Download negative keywords | TikTok API for Business",
      "description": "Use this endpoint to download the list of negative keywords for Search Ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825119068941314": {
      "title": "Get trending videos related to tracks Documentation",
      "description": "Use this endpoint to retrieve the top trending videos that use a popular track in a selected region."
    },
    "1740554223900674": {
      "title": "Ad Review Documentation | TikTok API for Business",
      "description": "This article explains \"Ad Review\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740859371033601": {
      "title": "Get App Retargeting Events | TikTok API for Business",
      "description": "Use this endpoint to obtain information about an App Retargeting Event, which can be used to define Audience Rules."
    },
    "1775104910010369": {
      "title": "Delete negative keywords | TikTok API for Business",
      "description": "Use this endpoint to get the list of negative keywords for Search Ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825298892472513": {
      "title": "Media Mix Modeling data request | TikTok API for Business",
      "description": "This article walks you through the steps to access Media Mix Modeling data through API. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1832184306529874": {
      "title": "Return codes Overview | TikTok API for Business",
      "description": "The following table lists the common return codes for unsuccessful calls to Business Messaging API. In this guide, you'll learn what to do, when to use it, and."
    },
    "1830173979548674": {
      "title": "Get the budget change history of an ad account Guide",
      "description": "Use this endpoint to retrieve the budget change history of an ad account within a Business Center. In this guide, you'll learn what to do, when to use it, and."
    },
    "1789703614085122": {
      "title": "Supported metrics in Video Insights reports Guide",
      "description": "You can use the following metrics in Video Insights reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1792139804568578": {
      "title": "Object ID uniqueness | TikTok API for Business",
      "description": "Each object within the TikTok API for Business is usually assigned an ID. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1781888800300034": {
      "title": "Step-by-step workflow | TikTok API for Business",
      "description": "Below are the steps you need to take before making your first API call. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1825128359356417": {
      "title": "Spark Ads Recommendation API | TikTok API for Business",
      "description": "This article explains \"Spark Ads Recommendation API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1805642902406145": {
      "title": "Mapping between Catalog Product Insights features in Catalog",
      "description": "This article explains \"Mapping between Catalog Product Insights features in Catalog Manager and API configurations\" and provides practical guidance for working."
    },
    "1769324038780930": {
      "title": "Manage URL properties | TikTok API for Business",
      "description": "Verifying ownership of video URLs is an essential step to comply with TikTok's policies around copyrighted content and user safety."
    },
    "1775104895291393": {
      "title": "Create negative keywords | TikTok API for Business",
      "description": "Use this endpoint to create negative keywords for Search Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739470744631298": {
      "title": "Create Spark Ads Guide | TikTok API for Business",
      "description": "This article walks you through the steps to create Spark Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738855242728450": {
      "title": "Create a developer app | TikTok API for Business",
      "description": "Before you can start integration, you need to create a developer app. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1832184379532289": {
      "title": "Webhooks Documentation | TikTok API for Business (Help)",
      "description": "This group consists of the following endpoints: - [Create a Business Messaging Webhook configuration](https://business-api.tiktok.com/portal."
    },
    "1740286998081538": {
      "title": "Creative tools Overview | TikTok API for Business",
      "description": "Creative tools provide a variety of simple and common assets (including images, videos and ads) preview, generation and optimization capabilities."
    },
    "1799004129683458": {
      "title": "Verify GTM setup Guide | TikTok API for Business",
      "description": "This article explains \"Verify GTM setup\" and provides practical guidance for working with TikTok API for Business."
    },
    "1797165504155649": {
      "title": "Payload Helper Overview | TikTok API for Business",
      "description": "This article explains \"Payload Helper\" and provides practical guidance for working with TikTok API for Business."
    },
    "1758428013689857": {
      "title": "Report an Offline Event | TikTok API for Business",
      "description": "Use this endpoint to report an offline event. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Report an Offline."
    },
    "1739470990574594": {
      "title": "(Deprecated) Layer naming guidelines Documentation",
      "description": "This article describes how to name the layers in a custom template for videos of ads, for example, Shopping Ads."
    },
    "1782086026530817": {
      "title": "Create Traffic ads Guide | TikTok API for Business",
      "description": "This article walks you through the steps to create Traffic ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740132921913346": {
      "title": "Catalog Feeds Overview | TikTok API for Business",
      "description": "This article explains \"Catalog Feeds\" and provides practical guidance for working with TikTok API for Business."
    },
    "1762228430145538": {
      "title": "Get all replies to a comment | TikTok API for Business",
      "description": "This article explains \"Get all replies to a comment\" and provides practical guidance for working with TikTok API for Business."
    },
    "1814122492598274": {
      "title": "Create Smart+ App Campaigns | TikTok API for Business",
      "description": "This article introduces how to create Smart+ App Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1744571207714818": {
      "title": "Manage a Reach & Frequency campaign Best Practices",
      "description": "This article introduces how to manage an Reach & Frequency (R&F) campaign. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1832184641212433": {
      "title": "Sort the automatic message for a Business Account",
      "description": "Use this endpoint to sort the chat prompts for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1758049779688450": {
      "title": "Events API: Offline | TikTok API for Business",
      "description": "This section introduces how to manage offline events through Events API. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1758053486938113": {
      "title": "Report Offline Events and Parameters Documentation",
      "description": "This article explains \"Report Offline Events and Parameters\" and provides practical guidance for working with TikTok API for Business."
    },
    "1762404685488130": {
      "title": "Supported metrics for a dimension in audience reports",
      "description": "See the tables below to learn about the supported metrics when you use a dimension in audience reports."
    },
    "1740858531237890": {
      "title": "Report a Web Event Guide | TikTok API for Business",
      "description": "Use this endpoint to report a Web Event. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Report a Web Event\"."
    },
    "1746998271267841": {
      "title": "Guides Best Practices | TikTok API for (Guide)",
      "description": "This guide will show you different audience types and steps to create and manage audiences through relevant APIs."
    },
    "1828185358712897": {
      "title": "Get TTO Public Account Insights | TikTok API for Business",
      "description": "This article explains \"Get TTO Public Account Insights\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739562439582722": {
      "title": "Guides Best Practices | TikTok API for Business",
      "description": "This guide walks you through Business Center creation, members and partners, payment settings, asset management, and Business Center reporting."
    },
    "1739566496956417": {
      "title": "Audience Management | TikTok API for Business",
      "description": "Audience is an ad targeting option that enables TikTok For Business advertisers to target or exclude specific users when setting up ads."
    },
    "1771100838106114": {
      "title": "Events API for App Guide | TikTok API for Business",
      "description": "This article explains \"Events API for App\" and provides practical guidance for working with TikTok API for Business."
    },
    "1774519076905985": {
      "title": "Configure destination and deeplink settings for",
      "description": "This article introduces how to configure specific destination and deeplink settings for Video Shopping Ads that promote websites."
    },
    "1740963089558529": {
      "title": "API reference Overview | TikTok API (Overview)",
      "description": "This article explains \"API reference\" and provides practical guidance for working with TikTok API for Business."
    },
    "1768506960432130": {
      "title": "Get authorization from Creators | TikTok API for Business",
      "description": "Steps 1. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get authorization from Creators\"."
    },
    "1749022727865345": {
      "title": "(Deprecated) Smart Video Soundtrack, Smart Video, and Quick",
      "description": "This article explains \"(Deprecated) Smart Video Soundtrack, Smart Video, and Quick Optimization\" and provides practical guidance for working with TikTok API."
    },
    "1853450329535490": {
      "title": "Get the TikTok Minis within an ad account Overview",
      "description": "Use this endpoint to retrieve the list of TikTok Minis within an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1753994950327297": {
      "title": "Link a pixel to ad accounts / Unlink Documentation",
      "description": "Use this endpoint to link a pixel to ad accounts, or to unlink a pixel from ad accounts. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1831564498409473": {
      "title": "Get the dynamic quota on Smart+ Campaigns Overview",
      "description": "Use this endpoint to get the dynamic quota on the number of active Smart+ Campaigns within an ad account."
    },
    "1830338948169794": {
      "title": "Update a TTO Creator Marketplace campaign Overview",
      "description": "Use this endpoint to update a TikTok One (TTO) Creator Marketplace campaign. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739029198660609": {
      "title": "Ad Comments - Blocked Words | TikTok API for Business",
      "description": "Blocked words are used to automatically hide comments. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Ad Comments."
    },
    "1775747432712194": {
      "title": "Business Center reports | TikTok API for Business",
      "description": "This article explains \"Business Center reports\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740029169927169": {
      "title": "Versioning Documentation | TikTok API for Business",
      "description": "The latest version for TikTok API For Business is v1.3. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1762228421622786": {
      "title": "Get post data of a TikTok account Best Practices",
      "description": "Use this endpoint to get reach and engagement data for all the public video, photo, or text posts of a TikTok account."
    },
    "1738811145996290": {
      "title": "Change Log Documentation | TikTok API for Business",
      "description": "The change logs show you the changes made to your ad account, campaigns, ad groups and ads. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1739916077352961": {
      "title": "Check the status of a download task Best Practices",
      "description": "Use this endpoint to check whether a change log download task has completed or not. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1842225270315074": {
      "title": "Delete a Custom Conversion | TikTok API for Business",
      "description": "Use this endpoint to delete a Custom Conversion for a Pixel or an App. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1839152005599234": {
      "title": "Get ad accounts linked to a Payment Portfolio Guide",
      "description": "Use this endpoint to retrieve the list of ad accounts linked to a Payment Portfolio. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1740245803888706": {
      "title": "Share audiences Guide | TikTok API for Business",
      "description": "Use this endpoint to start sharing audiences. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Share audiences\"."
    },
    "1843317474334722": {
      "title": "Get the review info of Upgraded Smart+ Ad creatives",
      "description": "Use this endpoint to retrieve the review results of creatives within Upgraded Smart+ Ads. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1739662727395330": {
      "title": "Get the partners of a BC | TikTok API for Business",
      "description": "Use this endpoint to get the list of partners of a Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739053563877378": {
      "title": "Download leads Overview | TikTok API for Business",
      "description": "Use this endpoint to download leads. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Download leads\"."
    },
    "1739324098894850": {
      "title": "(Deprecated) Get the quota for an iOS 14 Dedicated Campaign",
      "description": "This article explains \"(Deprecated) Get the quota for an iOS 14 Dedicated Campaign\" and provides practical guidance for working with TikTok API for Business."
    },
    "1769738105333826": {
      "title": "Get details of content exclusion categories Guide",
      "description": "This article explains \"Get details of content exclusion categories\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739470724723714": {
      "title": "(Deprecated) Create Dynamic Showcase Ads Overview",
      "description": "This article explains \"(Deprecated) Create Dynamic Showcase Ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1824721673497601": {
      "title": "Run a GMV Max Campaign report | TikTok API for Business",
      "description": "Use this endpoint to run a report on GMV Max Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Run a GMV."
    },
    "1832798361818114": {
      "title": "Get recommended search keywords | TikTok API for Business",
      "description": "This article explains \"Get recommended search keywords\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739315828649986": {
      "title": "Get campaigns Overview | TikTok API for Business",
      "description": "Use this endpoint to get all campaigns for an ad account. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1759233549899778": {
      "title": "Get identities with Showcase permission under an ad account",
      "description": "Use this endpoint to get identities with Showcase permission under an ad account. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1745292233615362": {
      "title": "Ad group Documentation | TikTok API for Business",
      "description": "After creating a campaign, you will need to set up your ad group. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1810521289122818": {
      "title": "Get TikTok account Webhook configurations Overview",
      "description": "Use this endpoint to retrieve the existing configurations for Webhook events related to your TikTok account activities at the developer app level."
    },
    "1755436556897281": {
      "title": "(Deprecated) Get available post-bid third-party measurement",
      "description": "Use this endpoint to get available post-bid third-party measurement partners, and the reason why you cannot choose a certain partner."
    },
    "1739473020978177": {
      "title": "Get Smart Creative materials | TikTok API for Business",
      "description": "Use this endpoint to get creative materials for Smart Creative ads, including call-to-actions, texts, ad names, images, or video materials."
    },
    "1832184488625234": {
      "title": "Get a Business Messaging Webhook configuration Guide",
      "description": "Use this endpoint to retrieve the existing configuration for Business Messaging Webhook events at the developer app level."
    },
    "1788755983247362": {
      "title": "New age restrictions for ads on TikTok Documentation",
      "description": "This article explains \"New age restrictions for ads on TikTok\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739516035501058": {
      "title": "BC Members Documentation | TikTok API for Business",
      "description": "This article explains \"BC Members\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843310524500993": {
      "title": "Ad groups Documentation | TikTok API for Business",
      "description": "Ad groups are the middle level of advertising. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Ad groups\"."
    },
    "1843317411665921": {
      "title": "Update an Upgraded Smart+ Ad | TikTok API for Business",
      "description": "Use this endpoint to update an Upgraded Smart+ Ad. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update an."
    },
    "1745292500427777": {
      "title": "(Deprecated) Create ACO ads | TikTok API for Business",
      "description": "> <span style=\"color:DodgerBlue\">**Note**</span><br> > ACO ads are no longer supported in API. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1804258360285186": {
      "title": "TopView Best Practices | TikTok API for Business",
      "description": "TopView is a video ad format that greets users immediately as they open TikTok. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1814122471133186": {
      "title": "Create Smart+ Web Campaigns | TikTok API for Business",
      "description": "This article introduces how to create Smart+ Web Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1739361739523073": {
      "title": "Creative assets Guide | TikTok API for Business",
      "description": "Creative assets refer to the multimedia elements presented to users in ads, such as videos and pictures."
    },
    "1760334598980610": {
      "title": "Get started Overview | TikTok API for Business (Overview)",
      "description": "Welcome to TikTok Accounts API! In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get started\"."
    },
    "1740492470201345": {
      "title": "Get the overview of a catalog | TikTok API for Business",
      "description": "Use this endpoint to get the number of products in different audit statuses (approved, rejected, and processing) in a catalog."
    },
    "1843301794874370": {
      "title": "Upgraded Smart+ Guide | TikTok API for Business",
      "description": "The Upgraded Smart+ Campaigns feature a new, unified workflow, known as the Upgraded Smart+ experience."
    },
    "1810515104773122": {
      "title": "Comment update event | TikTok API for Business",
      "description": "The comment update category includes the event `comment.update`. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739965624038402": {
      "title": "Authentication Overview | TikTok API for (Best Practices)",
      "description": "Authentication API enables you to generate or revoke long-term access tokens, and generate, renew, or revoke short-term access tokens."
    },
    "1740571821728770": {
      "title": "Appeal a rejection Guide | TikTok API for Business",
      "description": "Use this endpoint to appeal the rejection decision, that is, to request for the ad group to be re-evaluated, when your ad group is rejected during review."
    },
    "1824048170680450": {
      "title": "Age Gating Documentation | TikTok API for Business",
      "description": "This article explains \"Age Gating\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739361474981889": {
      "title": "Conversion events Guide | TikTok API for Business",
      "description": "App events The table below lists the enum values for conversion event (`optimization_event`) in App events for campaign management."
    },
    "1751088469160001": {
      "title": "Synchronous and asynchronous reports Documentation",
      "description": "You can run a report in synchronous mode or asynchronous mode. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739662779301890": {
      "title": "Delete a partner from a BC | TikTok API for Business",
      "description": "Use this endpoint to delete a partner in the Business Center. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1762405922636802": {
      "title": "(Deprecated) Supported metrics for a dimension in",
      "description": "See the tables below to learn about the supported metrics when you use a dimension in reservation ad reports."
    },
    "1739320994354178": {
      "title": "Update the operation statuses of campaigns Overview",
      "description": "Use this endpoint to enable, disable or delete a campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update."
    },
    "1833831427732481": {
      "title": "Enable brand hashtags for a Business Account Guide",
      "description": "Use this endpoint to enable hashtags for a Business Account. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1822009058467842": {
      "title": "Create GMV Max Campaigns | TikTok API for Business",
      "description": "This article walks you through the steps to create GMV Max Campaigns. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1777694366654465": {
      "title": "Attribution window and event count Best Practices",
      "description": "At the ad group level, you have the flexibility to set different attribution windows for your campaigns or ad groups."
    },
    "1754263135747073": {
      "title": "(Deprecated) Create catalog videos using custom templates",
      "description": "Catalog video can be a template video that features products listed in advertisers' catalog. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1738958351620097": {
      "title": "Identities Documentation | TikTok API for Business",
      "description": "This article explains \"Identities\" and provides practical guidance for working with TikTok API for Business."
    },
    "1771100965992450": {
      "title": "Event Deduplication | TikTok API for Business",
      "description": "This article explains \"Event Deduplication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1795190020378625": {
      "title": "Need support Overview | TikTok API for Business",
      "description": "This article explains \"Need support\" and provides practical guidance for working with TikTok API for Business."
    },
    "1740306481704961": {
      "title": "Create a catalog Guide | TikTok API for Business",
      "description": "Use this endpoint to create and set up your catalog using information such as name, targeted locations, and currency."
    },
    "1803630424390658": {
      "title": "Publish a photo post to an owned account Overview",
      "description": "Use this endpoint to publish a photo post to an owned TikTok Account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739940572667906": {
      "title": "Update an audience Guide | TikTok API for Business",
      "description": "Use this endpoint to update the details of an audience, like audience name and audience file. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1846868897541122": {
      "title": "Obtain a TikTok account ad delivery authorization URL",
      "description": "Use this endpoint to generate an authorization URL for requesting ad delivery permissions from a TikTok account."
    },
    "1740488375815169": {
      "title": "Get the lexicon list for a catalog Best Practices",
      "description": "Use this endpoint to get the lexicon for your catalog. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get the."
    },
    "1754000224141313": {
      "title": "Download asynchronously | TikTok API for Business",
      "description": "Use these endpoints to download historical invoices asynchronously. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1740554277061634": {
      "title": "Get review info of ad groups | TikTok API for Business",
      "description": "Use this endpoint to get information about the review of ad groups. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1774559446000642": {
      "title": "Limited Data Use Guide | TikTok API for Business (Guide)",
      "description": "This article explains \"Limited Data Use\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739940509849601": {
      "title": "Create an audience by rule | TikTok API for (Guide)",
      "description": "Use this endpoint to create an audience by rules. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1754726939130882": {
      "title": "Migrate to Video Shopping Ads | TikTok API for Business",
      "description": "This article explains \"Migrate to Video Shopping Ads\" and provides practical guidance for working with TikTok API for Business."
    },
    "1825107305621506": {
      "title": "Rate limits for Mentions API | TikTok API for Business",
      "description": "Global rate limits are applicable to Mentions API endpoints. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Rate."
    },
    "1780803525320706": {
      "title": "Mapping between Catalog Diagnostics features in Catalog",
      "description": "This article explains \"Mapping between Catalog Diagnostics features in Catalog Manager and API configurations\" and provides practical guidance for working with."
    },
    "1754000448122882": {
      "title": "Create an asynchronous download task Documentation",
      "description": "Use this endpoint to create an asynchronous download task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1739448126749698": {
      "title": "Unassign an asset Guide | TikTok API for Business",
      "description": "Use this endpoint to revoke the access to an asset from an user. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1780154462204930": {
      "title": "Saved Audience Overview | TikTok API for Business",
      "description": "Saved Audience allows you to store your targeting settings and reuse them to create future ad groups."
    },
    "1775752272288770": {
      "title": "BC Reporting Overview | TikTok API for Business",
      "description": "This article explains \"BC Reporting\" and provides practical guidance for working with TikTok API for Business."
    },
    "1843310542601218": {
      "title": "Reporting Documentation | TikTok API for (Tutorial)",
      "description": "You can use Reporting API to run a report on your ads data. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1739939050770434": {
      "title": "Update an ad account | TikTok API for Business",
      "description": "Use this endpoint to update ad accounts that were created in the Business Centers. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1762228448779266": {
      "title": "Reply to an existing comment on an owned video Guide",
      "description": "Use this endpoint to create a reply to an existing comment on an organic video posted by an owned TikTok Account or others' TikTok Account."
    },
    "1769325351919617": {
      "title": "Delete the verified ownership of an URL property",
      "description": "Use this endpoint to delete an advertiser account's verified ownership of an URL property (domain or URL prefix)."
    },
    "1742003478618114": {
      "title": "(To be deprecated)Create Catalog Listing Ads Guide",
      "description": "This article introduces how to create Catalog Listing Ads. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"(To be."
    },
    "1751454172429314": {
      "title": "Supported filters Guide | TikTok API for Business (Guide)",
      "description": "You can use the following filters to narrow down the scope of reporting results. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1843324606213121": {
      "title": "Create an Upgraded Smart+ Lead Generation Campaign (Guide)",
      "description": "This article explains \"Create an Upgraded Smart+ Lead Generation Campaign with Location as Website\" and provides practical guidance for working with TikTok API."
    },
    "1830112569774274": {
      "title": "Set or update the Brand Safety Hub settings of an ad account",
      "description": "Use this endpoint to set or update the Brand Safety Hub settings of an ad account. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1828185411810305": {
      "title": "Get TTO Public Media Insights | TikTok API for Business",
      "description": "This article explains \"Get TTO Public Media Insights\" and provides practical guidance for working with TikTok API for Business."
    },
    "1775747476019266": {
      "title": "Supported metrics Guide | TikTok API for (Tutorial)",
      "description": "You can use the following metrics in Business Center reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1737587293087810": {
      "title": "Video Best Practices | TikTok API for Business",
      "description": "Videos are a type of creative assets you can use to create an ad. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1737944775511041": {
      "title": "Accounts Documentation | TikTok API for Business",
      "description": "Business Account is an unique type of TikTok account intended for use by businesses on TikTok. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1738769098314754": {
      "title": "Get result details Guide | TikTok API for Business",
      "description": "Use this endpoint to get rule execution results by execution IDs. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738084416214017": {
      "title": "Rate limits Overview | TikTok API for Business (Guide)",
      "description": "The rate limit per authorized TikTok account and Accounts API endpoint is 40 queries per minute (QPM)."
    },
    "1738768750822466": {
      "title": "Get rules by ID Guide | TikTok API for Business",
      "description": "Use this endpoint to get rules by rule IDs. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get rules by ID\"."
    },
    "1739586761631745": {
      "title": "Update an ad group Guide | TikTok API for Business",
      "description": "Use this endpoint to update an ad group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update an ad group\"."
    },
    "1738674986981378": {
      "title": "Get diagnoses for ad groups | TikTok API for Business",
      "description": "Use this endpoint to get diagnoses, including possible issues and suggestions for corrections or improvements, for your active ad groups."
    },
    "1738763978290178": {
      "title": "Automated Rules Guide | TikTok API for Business",
      "description": "Automated Rules let you create rule-based tasks to automatically check and manage your campaigns, ad groups, and ads."
    },
    "1738767670852610": {
      "title": "Create rules Overview | TikTok API for Business",
      "description": "Use this endpoint to create automated rules. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create rules\"."
    },
    "1737721642924033": {
      "title": "Finish a chunk upload task | TikTok API for Business",
      "description": "Use this endpoint to finish a chunk upload task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Finish a chunk."
    },
    "1737586324313089": {
      "title": "Time zone Documentation | TikTok API for Business",
      "description": "The following table lists the available time zone codes and the corresponding time zones. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1737115635521538": {
      "title": "BC Management Overview | TikTok API for Business",
      "description": "This article explains \"BC Management\" and provides practical guidance for working with TikTok API for Business."
    },
    "1737585544915970": {
      "title": "Overview Documentation | TikTok API for (Best Practices)",
      "description": "This article gives an overview of campaign management. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Overview\"."
    },
    "1736271339521025": {
      "title": "Search for targeting hashtags | TikTok API for Business",
      "description": "Use this endpoint to search for targeting hashtags based on seed keywords. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1738084387220481": {
      "title": "Authentication Overview | TikTok API for (Overview)",
      "description": "This article explains \"Authentication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738455508553729": {
      "title": "Get authorized ad accounts | TikTok API for Business",
      "description": "Use this endpoint to obtain a list of advertiser accounts that authorized an app. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1738455961470977": {
      "title": "Get time zones Overview | TikTok API for Business",
      "description": "Use this endpoint to get time zone enumeration values, and their offsets from GMT. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1738235338194945": {
      "title": "Create an R&F ad group | TikTok API for Business",
      "description": "Use this endpoint to create a Reach & Frequency ad group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create."
    },
    "1737721229896705": {
      "title": "Start a file chunk upload task | TikTok API for Business",
      "description": "Use this endpoint to initiate a file chunk upload task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Start a."
    },
    "1738768861976578": {
      "title": "Get rules by filters | TikTok API for Business",
      "description": "Use this endpoint to get rules based on the values of certain filters. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1738376435339265": {
      "title": "Apply an authorization code | TikTok API for Business",
      "description": "Use this endpoint to apply an authorization code. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Apply an."
    },
    "1738376465972226": {
      "title": "Get Spark Ad posts Guide | TikTok API for Business",
      "description": "Use this endpoint to get a list of Spark Ads posts that have been authorized to an ad account. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1737719988918274": {
      "title": "Files Best Practices | TikTok API for Business",
      "description": "You can upload video, image and music files to TikTok's temporary file repository. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1737585562434561": {
      "title": "Advertising objective | TikTok API for Business",
      "description": "Advertising objective refers to the business goals that you want your campaigns to achieve. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1738235487941633": {
      "title": "Get inventory estimates | TikTok API for Business",
      "description": "Use this endpoint to get inventory estimates for Reach & Frequency ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737115687501826": {
      "title": "Get Business Centers | TikTok API for Business",
      "description": "Use this endpoint to obtain the list of Business Centers that an user has access to. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1738769076676609": {
      "title": "Get rule results Guide | TikTok API for Business",
      "description": "Use this endpoint to get the execution results of rules based on the values of certain filters. In this guide, you'll learn what to do, when to use it, and."
    },
    "1737732054892545": {
      "title": "Check the status of a playable creative Overview",
      "description": "Use this endpoint to check the validation and audit status of the uploaded playable creative. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1737172880570369": {
      "title": "Get device models Guide | TikTok API for Business",
      "description": "Use this endpoint to get device model enumeration values. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1738086301876225": {
      "title": "Get comments Overview | TikTok API for Business",
      "description": "Use this endpoint to get the comments under the video ads of an ad account. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737730926765057": {
      "title": "Upload a playable creative | TikTok API for Business",
      "description": "Use this endpoint to upload a playable creative. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload a playable."
    },
    "1738308662898689": {
      "title": "Get OS versions Guide | TikTok API for Business",
      "description": "Use this endpoint to get the enumeration values of operating system version. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737188554152962": {
      "title": "Get languages Overview | TikTok API for Business",
      "description": "Use this endpoint to get the enum values of language codes. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1737719523561474": {
      "title": "Create a campaign Guide | TikTok API for Business",
      "description": "This article introduces how to create a campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a."
    },
    "1737168013095938": {
      "title": "Get carriers Overview | TikTok API for Business",
      "description": "Use this endpoint to get the carrier enumeration values that represents carriers in different countries or locations."
    },
    "1736280889167874": {
      "title": "Get targeting hashtags by ID | TikTok API for Business",
      "description": "Use this endpoint to get the targeting hashtag names and statuses by ID. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1735735524758530": {
      "title": "Ads Best Practices | TikTok API for Business",
      "description": "An ad is the smallest advertising unit and is the content presented to the target audience. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1737174886619138": {
      "title": "Enumerations Overview | TikTok API for Business",
      "description": "This article explains \"Enumerations\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739357589575681": {
      "title": "Industries Documentation | TikTok API for Business",
      "description": "This article explains \"Industries\" and provides practical guidance for working with TikTok API for Business."
    },
    "1737107845597186": {
      "title": "Get a suggested bid | TikTok API for Business",
      "description": "This article explains \"Get a suggested bid\" and provides practical guidance for working with TikTok API for Business."
    },
    "1736271001971713": {
      "title": "Tools Best Practices | TikTok API for Business",
      "description": "Use this group of endpoints to get enumeration values or recommended values for commonly used fields such as regions, time zones, device models, etc."
    },
    "1735713609895937": {
      "title": "Get Started Overview | TikTok API for Business",
      "description": "Welcome to TikTok For Business Developers! In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get Started\"."
    },
    "1738376509936641": {
      "title": "Unbind a Spark Ad post | TikTok API for Business",
      "description": "Use this endpoint to unbind a Spark Ad post after the authorization has expired or has been revoked."
    },
    "1737191804348417": {
      "title": "Terms Best Practices | TikTok API for Business",
      "description": "Before you can use some features, such as Lead Generation Ads, you need to sign an agreement. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1740497429681153": {
      "title": "Upload products via a JSON schema Best Practices",
      "description": "Use this endpoint to upload products to the catalog in batch and you can upload up to 5000 products at a time."
    },
    "1735735588640770": {
      "title": "Get ads Best Practices | TikTok API for Business",
      "description": "Use this endpoint to get the data of regular ads and Smart Creative ads. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737192304571394": {
      "title": "Check the status of Terms | TikTok API for Business",
      "description": "Use this endpoint to check the status of an agreement. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Check the."
    },
    "1738769123170306": {
      "title": "Update rules Overview | TikTok API for Business",
      "description": "Use this endpoint to update the details of rules. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update rules\"."
    },
    "1737192284435457": {
      "title": "Sign Terms Documentation | TikTok API for Business",
      "description": "Use this endpoint to sign the agreement for the Lead Generation Ads feature. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1739953377508354": {
      "title": "Create ads Documentation | TikTok API for Business",
      "description": "Use this endpoint to upload your ad creatives (pictures, videos, texts, call-to-action) and create a regular ad."
    },
    "1737189539571713": {
      "title": "Get available locations by different settings Guide",
      "description": "This article explains \"Get available locations by different settings\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738086266983426": {
      "title": "Ad Comments Overview | TikTok API for Business",
      "description": "This article explains \"Ad Comments\" and provides practical guidance for working with TikTok API for Business."
    },
    "1735713713137730": {
      "title": "Use Cases Documentation | TikTok API for Business",
      "description": "TikTok API for Business enables you to build functions according to your business needs, making advertising more automated, intelligent and customized."
    },
    "1737174348712961": {
      "title": "Get general interest categories | TikTok API for Business",
      "description": "Use this endpoint to get general interest category enumeration values. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737719918220290": {
      "title": "Page Best Practices | TikTok API for Business",
      "description": "An instant page is a fast-loading lightweight web page that loads up to 11 times faster on TikTok than a standard web page."
    },
    "1739311040498689": {
      "title": "Location IDs Overview | TikTok API for Business",
      "description": "The following table provides a partial list of available location IDs. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737180852720642": {
      "title": "Get additional interest categories Best Practices",
      "description": "Use this group of endpoints to get additional interest categories (interest keywords). In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1738235402874882": {
      "title": "Update an R&F ad group | TikTok API for Business",
      "description": "Use this endpoint to update Reach & Frequency ad groups. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Update an."
    },
    "1735827019995138": {
      "title": "TikTok One API Overview | TikTok API for Business",
      "description": "This article explains \"TikTok One API\" and provides practical guidance for working with TikTok API for Business."
    },
    "1737732203851777": {
      "title": "Save a playable creative | TikTok API for Business",
      "description": "Use this endpoint to save a playable. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Save a playable creative\"."
    },
    "1735713875563521": {
      "title": "API Reference Overview | TikTok API for Business (Help)",
      "description": "Request URL format Request URLs are in the format of \\<base_url\\>/\\<api_version\\>/\\<endpoint\\>. In this guide, you'll learn what to do, when to use it, and."
    },
    "1738456743621634": {
      "title": "Get the authorization status of a Brand Safety partner",
      "description": "Use this endpoint to get the authorization status of your Brand Safety partner. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737172488964097": {
      "title": "Return codes Overview | TikTok API for Business (Guide)",
      "description": "This article explains \"Return codes\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738088242659330": {
      "title": "Get the status of a comment export task Overview",
      "description": "Use this endpoint to check the status of a comment export task. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738457335681026": {
      "title": "Get a TikTok in-app link | TikTok API for Business",
      "description": "Use this endpoint to get the corresponding TikTok in-app link for an open TikTok URL. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1737733368940546": {
      "title": "Delete a playable creative | TikTok API for Business",
      "description": "Use this endpoint to delete a playable creative. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Delete a playable."
    },
    "1738458086823938": {
      "title": "BC Billing Groups Guide | TikTok API for Business",
      "description": "This article explains \"BC Billing Groups\" and provides practical guidance for working with TikTok API for Business."
    },
    "1736275204260866": {
      "title": "Get recommended interest and action categories Guide",
      "description": "Use this endpoint to get recommended interest and action categories based on historical performance data in the same industries."
    },
    "1737730803189826": {
      "title": "Playable Ads Overview | TikTok API for Business",
      "description": "Playable Ad is an interactive ad format that provides a short, engaging experience attracting users and getting them to download your app or game."
    },
    "1738376238825474": {
      "title": "Spark Ads Using Authorized Posts | TikTok API for Business",
      "description": "This section introduces the endpoints that help you create or update Spark Ads using authorized posts."
    },
    "1740562287852546": {
      "title": "Update products Guide | TikTok API for Business",
      "description": "Use this endpoint to update products in a catalog in batch and you can update up to 5000 products at a time."
    },
    "1739091934311426": {
      "title": "Creative Portfolios | TikTok API for Business",
      "description": "A creative portfolio is a combination of creative assets like CTAs and Download Cards. In this guide, you'll learn what to do, when to use it, and what to."
    },
    "1737944384433218": {
      "title": "Overview Documentation | TikTok (Overview)",
      "description": "Business Account is an unique type of TikTok account intended for use by businesses on TikTok. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1738458108705794": {
      "title": "Get the advertiser list of a Billing Group Overview",
      "description": "Use this endpoint to get the list of advertisers that are bound to a Billing Group. In this guide, you'll learn what to do, when to use it, and what to check."
    },
    "1737721489945601": {
      "title": "Transfer a file chunk | TikTok API for Business",
      "description": "Use this endpoint to transfer a file chunk. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Transfer a file chunk\"."
    },
    "1738088144215041": {
      "title": "Create a comment export task | TikTok API for Business",
      "description": "Use this endpoint to create a comment export task. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a."
    },
    "1737585867307010": {
      "title": "Location code Overview | TikTok API for Business",
      "description": "This article explains \"Location code\" and how to apply it when working with TikTok API for Business."
    },
    "1737172315193346": {
      "title": "Appendix Documentation | TikTok API for Business (Guide)",
      "description": "This chapter lists the following appendix articles. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Appendix\"."
    },
    "1738086824859650": {
      "title": "Get related comments | TikTok API for Business",
      "description": "Use this endpoint to get related comments. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get related comments\"."
    },
    "1738674938808321": {
      "title": "Ad Diagnosis Overview | TikTok API for Business",
      "description": "Ad diagnosis is a feature that analyzes your ad groups, detects issues, and provides suggestions for corrections or improvements."
    },
    "1737191909315585": {
      "title": "Get Terms Documentation | TikTok API for Business",
      "description": "Use this endpoint to get the agreement for the Lead Generation Ads feature. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1737565048641538": {
      "title": "Accounts API Overview | TikTok API for Business",
      "description": "With Accounts API, you can manage and report on Business Account and Personal Account activity programmatically, providing deep insights and scaled control."
    },
    "1738235311704065": {
      "title": "Reach & Frequency Guide | TikTok API for Business (Guide)",
      "description": "Reach & Frequency (R&F) is a campaign buying type that helps TikTok For Business advertisers plan and buy campaigns in advance."
    },
    "1737585839634433": {
      "title": "Budget verification ratio and value range for each currency",
      "description": "This article explains \"Budget verification ratio and value range for each currency\" and provides practical guidance for working with TikTok API for Business."
    },
    "1738083939371009": {
      "title": "Authorization Overview | TikTok API for Business (Help)",
      "description": "Before you use the Accounts API, you (the developer) need to first get authorization from the business to manage their accounts."
    },
    "1843314887930946": {
      "title": "Create an Upgraded Smart+ Ad Group Best Practices",
      "description": "Use this endpoint to create an Upgraded Smart+ Ad Group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an."
    },
    "1738769144119298": {
      "title": "Update the statuses of rules | TikTok API for Business",
      "description": "Use this endpoint to turn on, turn off, or delete a group of rules. In this guide, you'll learn what to do, when to use it, and what to check when implementing."
    },
    "1738455259137026": {
      "title": "Ad Accounts Overview | TikTok API for Business",
      "description": "An advertiser account is the basic account on TikTok For Business platform. In this guide, you'll learn what to do, when to use it, and what to check when."
    },
    "1751443967255553": {
      "title": "Supported metrics Guide | TikTok API for Business",
      "description": "You can use the following metrics in basic reports. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Supported."
    },
    "1737587322856449": {
      "title": "Upload a video Overview | TikTok API for Business",
      "description": "Use this endpoint to upload a video to the Asset Library and use the obtained video ID for creating ads."
    },
    "1738086844585985": {
      "title": "Update the statuses of comments | TikTok API for Business",
      "description": "Use this endpoint to change the statuses of a list of comments from public to hidden, or vice versa."
    },
    "1738373164380162": {
      "title": "Authentication Overview | TikTok API for Business (Guide)",
      "description": "This article explains \"Authentication\" and provides practical guidance for working with TikTok API for Business."
    },
    "1737732758495234": {
      "title": "Get playable creatives | TikTok API for Business",
      "description": "Use this endpoint to get a list of playables. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get playable."
    },
    "1767334204047362": {
      "title": "Create a Smart+ Campaign | TikTok API for Business (Guide)",
      "description": "Use this endpoint to create a Smart+ Campaign. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create a Smart+."
    },
    "1738376324021250": {
      "title": "Get info about a Spark Ad post | TikTok API for Business",
      "description": "Use this endpoint to get information about the Spark Ads post that you have been authorized to use as an ad."
    },
    "1735827359532033": {
      "title": "TikTok One Documentation | TikTok API for Business",
      "description": "This article explains \"TikTok One\" and provides practical guidance for working with TikTok API for Business."
    },
    "1739499616346114": {
      "title": "Create an ad group Guide | TikTok API for Business (Guide)",
      "description": "Use this endpoint to create an ad group. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Create an ad group\"."
    },
    "1737720893061122": {
      "title": "Upload a file Overview | TikTok API for Business",
      "description": "Use this endpoint to upload a file. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Upload a file\"."
    },
    "1738373141733378": {
      "title": "Authorization Overview | TikTok API for Business (Guide)",
      "description": "Before you use the Marketing API, you (the developer) need to first get authorization from the advertiser to manage their accounts."
    },
    "1843337909199938": {
      "title": "Supported ad-level metrics for Upgraded Smart+ Creative",
      "description": "The following tables list the metrics you can query at the ad level in Upgraded Smart+ Creative Overview Reports and Upgraded Smart+ Creative Breakdown Reports."
    },
    "1737166752522241": {
      "title": "Get action categories | TikTok API for Business",
      "description": "Use this endpoint to get action category enumeration values. In this guide, you'll learn what to do, when to use it, and what to check when implementing \"Get."
    },
    "1737583624272897": {
      "title": "Creative Tools Overview | TikTok API for Business",
      "description": "Creative tools provide a variety of simple and common assets (including images, videos and ads) preview, generation and optimization capabilities."
    },
    "1738088341958658": {
      "title": "Download exported comments | TikTok API for Business",
      "description": "Use this endpoint to download the exported data after an export task completes successfully. In this guide, you'll learn what to do, when to use it, and what."
    },
    "1736271785207810": {
      "title": "Creatives Documentation | TikTok API for Business",
      "description": "You can use Creative API to manage your creative assets, use creative tools and run creative reports."
    },
    "1740029165513730": {
      "title": "What's New Documentation | TikTok API for Business",
      "description": "Refer to the following tables to learn about the product or doc changes in TikTok API for Business. In this guide, you'll learn what to do, when to use it, and."
    }
  }
};

export function getSEOConfig(docId: number | string) {
  const id = String(docId);
  return seoConfig.articles[id] || seoConfig.default;
}
